/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(2), __webpack_require__(4), __webpack_require__(5), __webpack_require__(6), __webpack_require__(7), __webpack_require__(8), __webpack_require__(9), __webpack_require__(13), __webpack_require__(14), __webpack_require__(15)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_header, _filter, _review, _sleepBenefits, _sleepSteps, _deepstateTechnology, _homeNewsCarousel, _buy_together, _cartBuyTogether, _productGallery, _productShortDescription) {
  "use strict";

  /*Para minificar o arquivo rode
   gulp watchJs --fn=custom --src=catalog/view/theme/abriu_dormiu/javascript
   */

  $(function () {
    var $module = $(".page-common-home .layout-content-top > .product_module").first();
    var $titleWrap = $module.find(".heading-title-div").first();
    var $carousel = $module.find(".swiper, .product-list-carousel, .product-list-content.row").first();
    var link = $titleWrap.find(".heading-title a").attr("href");
    if (!$module.length || !$titleWrap.length || !$carousel.length || !link) return;
    if ($module.find(".ad-home-product-list__subtitle, .ad-home-product-list__footer").length) return;
    $module.addClass("ad-home-product-list");
    $titleWrap.append('<p class="ad-home-product-list__subtitle">Tecnologia Deepstate® em todos <span class="ad-home-product-list__dot"></span> 100 noites de teste</p>');
    $carousel.after("<div class=\"ad-home-product-list__footer\"><a class=\"ad-home-product-list__cta\" href=\"".concat(link, "\">Ver todos os produtos</a></div>"));
  });
  $(function () {
    var $page = $(".page-product-product").first();
    var $panel = $page.find("[data-floating-panel]").first();
    var getSourceStockGroup = function getSourceStockGroup() {
      var $groups = $page.find("#product .product_options_list").filter(function () {
        return $(this).find(".sizes").length;
      });
      var $principalGroup = $groups.filter("[data-principal='1']").first();
      return $principalGroup.length ? $principalGroup : $groups.first();
    };
    var $sourceStockGroup = getSourceStockGroup();
    if (!$panel.length || !$sourceStockGroup.length) return;
    $panel.addClass("floating-panel--stock-grid");
    var updateFloatingPanelVisibility = function updateFloatingPanelVisibility() {
      $panel.toggleClass("floating-panel--active", $panel.is(":visible"));
    };
    updateFloatingPanelVisibility();
    if (typeof MutationObserver !== "undefined") {
      new MutationObserver(updateFloatingPanelVisibility).observe($panel.get(0), {
        attributes: true,
        attributeFilter: ["style"]
      });
    }
    $panel.find(".floating-panel__quantity-label").each(function () {
      $(this).text($(this).text().replace(/:\s*$/, ""));
    });
    var $panelOptions = $panel.find(".floating-panel__options").first();
    if (!$panelOptions.length) {
      var $sourceContainer = $sourceStockGroup.closest(".product-radio-wrap, .product-options-list, .form-group, .option").first();
      var $stockContent = ($sourceContainer.length ? $sourceContainer : $sourceStockGroup).clone(false, false);
      $stockContent.find("[id]").removeAttr("id");
      $stockContent.find("label[for]").removeAttr("for");
      $stockContent.find("input, select, textarea").removeAttr("id name").prop("disabled", true);
      $panelOptions = $('<div class="floating-panel__options"></div>').append($stockContent);
      var $panelActions = $panel.find(".floating-panel__actions").first();
      if ($panelActions.length) {
        $panelOptions.insertBefore($panelActions);
      } else {
        $panel.find(".floating-panel__body").first().append($panelOptions);
      }
    }
    $panelOptions.addClass("floating-panel__stock-grid");
    $panelOptions.find("[data-floating-options-dropdown]").removeAttr("hidden");
    var $optionGroups = $panelOptions.find(".product_options_list");
    var $principalGroup = $optionGroups.filter("[data-principal='1']").first();
    var $stockGroup = $principalGroup.length ? $principalGroup : $optionGroups.first();
    if (!$stockGroup.length) return;
    var normalizeStockLabel = function normalizeStockLabel(value) {
      return (value || "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase();
    };
    var stockDimensions = {};
    if (typeof productAttributes !== "undefined" && Array.isArray(productAttributes)) {
      productAttributes.forEach(function (group) {
        (group.attribute || []).forEach(function (attribute) {
          if (!attribute.name || !attribute.text) return;
          stockDimensions[normalizeStockLabel(attribute.name)] = attribute.text.trim();
        });
      });
    }
    $optionGroups.not($stockGroup).each(function () {
      $(this).closest(".product-radio-wrap, .option, .form-group").first().hide();
    });
    $stockGroup.addClass("floating-panel__stock-grid-values");
    $stockGroup.find(".sizes").each(function () {
      var $value = $(this);
      var valueTitle = ($value.attr("title") || "").trim();
      var valueText = $value.clone().find("input, .alert-quantity, .grid_remove_selected, .optionValueQuantityInline").remove().end().text().replace(/\s+/g, " ").trim();
      var displayText = valueText.length > valueTitle.length ? valueText : valueTitle;
      var dimensionMatch = displayText.match(/\d+(?:[.,]\d+)?\s*m?\s*[xX\u00D7]\s*\d+(?:[.,]\d+)?\s*m?/i);
      var attributeDimension = stockDimensions[normalizeStockLabel(valueTitle || displayText)] || "";
      var dimension = dimensionMatch ? dimensionMatch[0] : attributeDimension;
      var label = displayText.replace(dimension, "").replace(/^[\s\-|]+|[\s\-|]+$/g, "").trim();
      $value.addClass("floating-panel__stock-grid-value").attr({
        "data-floating-label": label || displayText,
        tabindex: "0"
      });
      if (dimension) {
        $value.attr("data-floating-detail", dimension);
      }
    });
    var updatePanelSelection = function updatePanelSelection() {
      var selected_option_ids = getSourceStockGroup().find(".sizes.selected").map(function () {
        return String($(this).data("productOptionValueId"));
      }).get();
      $stockGroup.find(".sizes").each(function () {
        var $value = $(this);
        var is_selected = selected_option_ids.includes(String($value.data("productOptionValueId")));
        $value.toggleClass("selected", is_selected).attr("aria-pressed", is_selected ? "true" : "false");
      });
    };
    $stockGroup.on("click.abriuDormiuFloatingStock", ".sizes", function (event) {
      event.preventDefault();
      event.stopPropagation();
      var option_value_id = String($(this).data("productOptionValueId"));
      var $sourceValue = getSourceStockGroup().find(".sizes").filter(function () {
        return String($(this).data("productOptionValueId")) === option_value_id;
      }).first();
      if ($sourceValue.length) {
        $sourceValue.trigger("click");
      }
      window.setTimeout(updatePanelSelection, 0);
    });
    $stockGroup.on("keydown.abriuDormiuFloatingStock", ".sizes", function (event) {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      $(this).trigger("click");
    });
    $page.on("click.abriuDormiuFloatingStock", "#product .product_options_list .sizes", function () {
      window.setTimeout(updatePanelSelection, 0);
    });
    $(document).on("ajaxComplete.abriuDormiuFloatingStock", function () {
      window.setTimeout(updatePanelSelection, 0);
    });
    var $initialSourceGroup = getSourceStockGroup();
    if (!$initialSourceGroup.find(".sizes.selected").length) {
      $initialSourceGroup.find(".sizes").first().trigger("click");
    }
    updatePanelSelection();
    var formatFloatingPrice = function formatFloatingPrice() {
      $panel.find(".floating-panel__price-content .discount_simulator").each(function () {
        var $separator = $(this).children().first();
        if ($separator.is("span") && $separator.next("b").length) {
          $separator.addClass("floating-panel__price-separator");
        }
      });
    };
    var priceContent = $panel.find(".floating-panel__price-content").get(0);
    formatFloatingPrice();
    if (priceContent && typeof MutationObserver !== "undefined") {
      new MutationObserver(formatFloatingPrice).observe(priceContent, {
        childList: true,
        subtree: true
      });
    }
  });
  $(function () {
    $(".page-product-product #floating-panel-cart").on("click", function (event) {
      var $options = $("#product .product_options_list, #product .product-options-list, #product .options-list").first();
      var hasSelectedOption = $("#product .sizes.selected, #product .size.selected, #product input:checked, #product select").filter(function () {
        return this.tagName !== "SELECT" || this.value;
      }).length;
      if (!window.matchMedia("(max-width: 1023px)").matches || !$options.length || hasSelectedOption) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      $("html, body").animate({
        scrollTop: Math.max($options.offset().top - 120, 0)
      }, 300);
    });
  });
  function getYoutubeVideoId(value) {
    var rawValue = (value || "").toString().trim();
    if (!rawValue) return "";
    if (/^[a-zA-Z0-9_-]{11}$/.test(rawValue)) return rawValue;
    try {
      var url = new URL(rawValue);
      if (url.searchParams.get("v")) return url.searchParams.get("v").trim();
      if (url.hostname.includes("youtu.be")) return url.pathname.replace(/\//g, "").trim();
      var pathParts = url.pathname.split("/").filter(Boolean);
      return pathParts[pathParts.length - 1] || "";
    } catch (error) {
      return "";
    }
  }
  function createYoutubeIframe(videoId, title) {
    var iframe = document.createElement("iframe");
    iframe.src = "https://www.youtube.com/embed/".concat(encodeURIComponent(videoId), "?autoplay=1&mute=1&loop=1&playlist=").concat(encodeURIComponent(videoId), "&playsinline=1&controls=0&rel=0&modestbranding=1&iv_load_policy=3&disablekb=1&fs=0");
    iframe.title = title || "Vídeo";
    iframe.allow = "autoplay; encrypted-media; picture-in-picture; web-share";
    iframe.loading = "eager";
    iframe.referrerPolicy = "strict-origin-when-cross-origin";
    iframe.allowFullscreen = false;
    return iframe;
  }
  function loadLazyVideo($root) {
    var $button = $root.find(".js-lazy-video-button").first();
    var $frame = $root.find(".js-lazy-video-frame").first();
    var videoId = getYoutubeVideoId($root.data("videoId") || $root.data("videoUrl"));
    var title = ($root.data("videoTitle") || "Vídeo").toString().trim();
    if (!$root.length || !$frame.length || !videoId || $root.data("videoLoaded")) {
      return;
    }
    $root.data("videoLoaded", true);
    $frame.empty().append(createYoutubeIframe(videoId, title)).prop("hidden", false);
    $button.prop("hidden", true);
  }
  $(document).on("click", ".js-lazy-video-button", function () {
    loadLazyVideo($(this).closest(".js-lazy-video"));
  });
  function observeAutoplayLazyVideo($root) {
    if (!("IntersectionObserver" in window)) {
      loadLazyVideo($root);
      return;
    }
    var element = $root[0];
    var observer = new IntersectionObserver(function (entries, currentObserver) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        currentObserver.unobserve(entry.target);
        loadLazyVideo($(entry.target));
      });
    }, {
      rootMargin: "600px 0px",
      threshold: 0
    });
    observer.observe(element);
  }
  function isMattressTitle(title) {
    var normalizedTitle = title.toLowerCase();
    return normalizedTitle.includes("colchão") || normalizedTitle.includes("colchao");
  }
  $(function () {
    if (!isMattressTitle($(".page-product-product .product-title.title").first().text())) return;
    var $prices = $(".page-product-product #product > .product-prices-content").first();
    if ($prices.length && !$prices.next(".mattress-trial-banner").length) {
      $prices.after('<a href="https://www.abriudormiu.com.br/politica-de-teste-100-cem-noites-de-sono" class="mattress-trial-banner" target="_blank" rel="noopener">Política 100 noites de teste</a>');
    }
    var $description = $(".page-product-product #product .product-short-description").first();
    if ($description.length && $(".page-product-product [data-tab='colchao-care']").length && !$description.next(".mattress-care-trigger").length) {
      $description.after('<div class="mattress-care-trigger" data-head-tab="colchao-care"><span>Cuidados com o colchão</span></div>');
    }
  });
  $(function () {
    var $content = $(".js-product-purchase-info").first();
    var $prices = $(".page-product-product #product > .product-prices-content").first();
    if (!$content.length || !$prices.length) return;
    var isMattress = isMattressTitle($(".product-title.title").first().text());
    var $anchor = $prices;
    if (isMattress) {
      var $careTrigger = $(".mattress-care-trigger").first();
      var $description = $("#product .product-short-description").first();
      $anchor = $careTrigger.length ? $careTrigger : $description.length ? $description : $prices;
    } else {
      $content.find(".is-mattress-only").remove();
      $content.find(".product-purchase-info__row").filter(function (_, row) {
        return !row.children.length;
      }).remove();
    }
    $content.insertAfter($anchor).show();
  });
  $(document).on("click", "[data-head-tab='colchao-care']", function () {
    $("[data-tab='colchao-care']").addClass("open").closest(".product-shop-informations-group").addClass("open");
    $(".tab-backdrop").fadeIn();
  });
  $(function () {
    $(".js-lazy-video[data-video-autoplay='true']").each(function () {
      observeAutoplayLazyVideo($(this));
    });
  });
  $(function () {
    $(".product.product-grid").each(function () {
      var $product = $(this);
      var title = $product.find(".product-title a").text();
      if (!isMattressTitle(title)) return;
      var $priceOld = $product.find(".product-price-old");
      var $target = $priceOld.length ? $priceOld : $product.find(".product-price");
      if ($target.length) {
        $target.before('<span class="starting-at-label">A partir de </span>');
      }
    });
  });
});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function () {
  "use strict";

  var SELECTORS = {
    body: 'body',
    drawer: '.header__drawer',
    searchRoot: '.form-search',
    searchPanel: 'fieldset',
    searchBackdrop: '.page-header-search__backdrop',
    searchInput: '.page-header-search__input',
    categoryContainer: '.page-header-categories__container',
    categoryDetails: '.page-header-categories__details',
    categoryPanel: '.page-header-categories__content',
    categorySection: '.page-header-categories__section',
    categoryTrigger: '.page-header-categories__summary'
  };
  var DRAWERS = {
    cart: '#header__drawer-cart',
    account: '#header__drawer-account',
    menu: '#header__drawer-menu'
  };
  var getSearchRoot = function getSearchRoot(trigger) {
    var $root = $(trigger).closest(SELECTORS.searchRoot);
    return $root.length ? $root : $(SELECTORS.searchRoot).first();
  };
  var hasOpenOverlay = function hasOpenOverlay() {
    return $("".concat(SELECTORS.drawer, ".open")).length > 0 || $("".concat(SELECTORS.searchRoot, " ").concat(SELECTORS.searchPanel, ".open-search")).length > 0;
  };
  var syncBodyLock = function syncBodyLock() {
    $(SELECTORS.body).toggleClass('drawer-open', hasOpenOverlay());
  };
  var toggleDrawer = function toggleDrawer(name, shouldOpen) {
    $(DRAWERS[name]).toggleClass('open', shouldOpen);
    syncBodyLock();
  };
  var isCartQuantityUpdating = false;
  var initCartQuantitySteppers = function initCartQuantitySteppers() {
    var $inputs = $("".concat(DRAWERS.cart, " input[name=\"product_quantity\"]"));
    if (!$inputs.length || typeof $.fn.stepper !== 'function') {
      return;
    }
    $inputs.each(function () {
      var $input = $(this);
      if ($input.hasClass('stepper-input')) {
        $input.closest('.stepper').addClass('stepper--cart');
        return;
      }
      $input.stepper({
        customClass: 'stepper--cart',
        labels: {
          up: '',
          down: ''
        }
      });
    });
  };
  var toggleCartQuantityControls = function toggleCartQuantityControls(isDisabled) {
    var $inputs = $("".concat(DRAWERS.cart, " input[name=\"product_quantity\"]"));
    $inputs.prop('disabled', isDisabled).closest('.stepper').toggleClass('disabled', isDisabled);
  };
  var showCartQuantitySpinner = function showCartQuantitySpinner($input) {
    var $card = $input.closest('.cart-drawer__product-card');
    if (!$card.length || $card.find('.cart-drawer__quantity-loader').length) {
      return;
    }
    $card.addClass('cart-drawer__product-card--loading').append("\n            <div class=\"cart-drawer__quantity-loader\" aria-hidden=\"true\">\n                <svg xmlns=\"http://www.w3.org/2000/svg\" height=\"48px\" viewBox=\"0 -960 960 960\" width=\"48px\" fill=\"#cdcdcd\"><path d=\"M480-80q-84 0-157-31t-127-85q-54-54-85-127T80-480q0-84 31-157t85-127q54-54 127-85t157-31q12 0 21 9t9 21q0 12-9 21t-21 9q-141 0-240.5 99.5T140-480q0 141 99.5 240.5T480-140q141 0 240.5-99.5T820-480q0-12 9-21t21-9q12 0 21 9t9 21q0 84-31 157t-85 127q-54 54-127 85T480-80Z\"/></svg>\n            </div>\n        ");
  };
  var hideCartQuantitySpinner = function hideCartQuantitySpinner($input) {
    $input.closest('.cart-drawer__product-card').removeClass('cart-drawer__product-card--loading').find('.cart-drawer__quantity-loader').remove();
  };
  var finishCartQuantityUpdate = function finishCartQuantityUpdate() {
    isCartQuantityUpdating = false;
    toggleCartQuantityControls(false);
    $("".concat(DRAWERS.cart, " .cart-drawer__product-card--loading")).removeClass('cart-drawer__product-card--loading').find('.cart-drawer__quantity-loader').remove();
  };
  window.openSearch = function (trigger) {
    var $root = getSearchRoot(trigger);
    $root.find(SELECTORS.searchPanel).addClass('open-search');
    $root.find(SELECTORS.searchBackdrop).addClass('active');
    syncBodyLock();
    $root.find(SELECTORS.searchInput).first().trigger('focus');
  };
  window.closeSearch = function (trigger) {
    var $root = getSearchRoot(trigger);
    $root.find(SELECTORS.searchPanel).removeClass('open-search');
    $root.find(SELECTORS.searchBackdrop).removeClass('active');
    syncBodyLock();
  };
  window.openCart = function () {
    toggleDrawer('cart', true);
    initCartQuantitySteppers();
  };
  window.closeCart = function () {
    return toggleDrawer('cart', false);
  };
  window.openAccount = function () {
    return toggleDrawer('account', true);
  };
  window.closeAccount = function () {
    return toggleDrawer('account', false);
  };
  window.openMenu = function () {
    return toggleDrawer('menu', true);
  };
  window.closeMenu = function () {
    return toggleDrawer('menu', false);
  };
  window.refreshCart = function () {
    loadQuantityItensCart();
    cartTotal();
    loadCartProducts();
    window.setTimeout(function () {
      $('.content-loader').removeClass('open');
    }, 2000);
  };
  window.deleteProductCart = function (key) {
    $('.content-loader').toggleClass('open');
    $.ajax({
      url: 'index.php?route=checkout/cart/remove',
      type: 'post',
      data: "key=".concat(encodeURIComponent(key)),
      dataType: 'json',
      success: function success() {
        $('.content-loader').removeClass('open');
        window.refreshCart();
      },
      error: function error(response) {
        alert(response.responseText);
      }
    });
  };
  window.updateCartProductQuantity = function (input) {
    if (isCartQuantityUpdating) {
      return;
    }
    var $input = $(input);
    var productKey = $input.data('productKey');
    var minQuantity = Number($input.attr('min')) || 1;
    var parsedQuantity = parseInt($input.val(), 10);
    var quantity = Math.max(isNaN(parsedQuantity) ? minQuantity : parsedQuantity, minQuantity);
    if (!productKey) {
      return;
    }
    isCartQuantityUpdating = true;
    $input.val(quantity);
    toggleCartQuantityControls(true);
    showCartQuantitySpinner($input);
    $.ajax({
      url: 'index.php?route=checkout/cart/edit',
      type: 'post',
      data: "key=".concat(encodeURIComponent(productKey), "&quantity=").concat(encodeURIComponent(quantity)),
      dataType: 'json',
      success: function success() {
        window.refreshCart();
      },
      error: function error(response) {
        hideCartQuantitySpinner($input);
        finishCartQuantityUpdate();
        alert(response.responseText);
      }
    });
  };
  $(function () {
    initCartQuantitySteppers();
    $(document).on('change', "".concat(DRAWERS.cart, " input[name=\"product_quantity\"]"), function () {
      window.updateCartProductQuantity(this);
    }).on('ajaxComplete', function (event, xhr, settings) {
      if (settings.url && settings.url.includes('route=common/cart/info')) {
        initCartQuantitySteppers();
        finishCartQuantityUpdate();
      }
    });
    $(document).on('shown.bs.modal', '#modal-cart', function () {
      $('#modal-cart').remove();
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open').removeAttr('style');
      if (typeof window.loadQuantityItensCart === 'function') {
        window.loadQuantityItensCart();
      }
      if (typeof window.cartTotal === 'function') {
        window.cartTotal();
      }
      if (typeof window.loadCartProducts === 'function') {
        window.loadCartProducts();
      }
      window.setTimeout(function () {
        window.openCart();
      }, 150);
    });
    var closeSubmenu = function closeSubmenu($details) {
      var panelTarget = $details.data('panel-target');
      var $panel = panelTarget ? $("#".concat(panelTarget)) : $();
      var $container = $details.closest(SELECTORS.categoryContainer);
      $details.removeClass('is-open');
      $panel.removeClass('is-open');
      $container.css('--submenu-height', '0px');
    };
    var closeAllSubmenus = function closeAllSubmenus($scope) {
      var $container = $scope.closest(SELECTORS.categoryContainer).length ? $scope.closest(SELECTORS.categoryContainer) : $(SELECTORS.categoryContainer);
      $container.find(SELECTORS.categoryDetails).removeClass('is-open');
      $container.find(SELECTORS.categoryPanel).removeClass('is-open');
      $container.css('--submenu-height', '0px');
    };
    var openSubmenu = function openSubmenu($details) {
      var $container = $details.closest(SELECTORS.categoryContainer);
      var panelTarget = $details.data('panel-target');
      var $panel = panelTarget ? $("#".concat(panelTarget)) : $();
      var $section = $panel.find(SELECTORS.categorySection).first();
      var submenuHeight = $section.length ? Math.ceil($section.outerHeight(true) + 32) : 0;
      $container.find(SELECTORS.categoryDetails).not($details).removeClass('is-open');
      $container.find(SELECTORS.categoryPanel).not($panel).removeClass('is-open page-header-categories__content--always-open');
      $details.addClass('is-open');
      $container.css('--submenu-height', "".concat(submenuHeight, "px"));
      $panel.addClass('is-open');
    };
    $(document).on('click', "".concat(SELECTORS.categoryTrigger, ", ").concat(SELECTORS.categoryTrigger, " a"), function (event) {
      event.preventDefault();
      event.stopPropagation();
      var $details = $(this).closest(SELECTORS.categoryDetails);
      if ($details.hasClass('is-open')) {
        return;
      }
      openSubmenu($details);
    });
  });
});

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_utils) {
  "use strict";

  var DESKTOP_QUERY = window.matchMedia("(min-width: 1025px)");
  var FILTER_SELECTOR = "#content-filters-v2--top, #content-filters-v2--left";
  var FILTER_GROUP_SELECTOR = ".filterForm > .filters";
  var FILTER_FORM_SELECTOR = ".filterForm";
  var FILTER_PRICE_SELECTOR = ".filter-price-container";
  var OPEN_CLASS = "ad-filters-open";
  var BODY_OPEN_CLASS = "ad-filters-lock";
  var SINGLE_GROUP_CLASS = "ad-filters-single-group";
  var SINGLE_GROUP_INLINE_MOBILE_CLASS = "ad-filters-single-group-inline-mobile";
  var DRAWER_CLOSE_ICON = "\n  <svg width=\"9\" height=\"9\" viewBox=\"0 0 9 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" focusable=\"false\">\n    <path d=\"M8.56055 1.06055L5.34082 4.28027L8.56055 7.5L7.5 8.56055L4.28027 5.34082L1.06055 8.56055L0 7.5L3.21973 4.28027L0 1.06055L1.06055 0L4.28027 3.21973L7.5 0L8.56055 1.06055Z\" fill=\"#192950\"/>\n  </svg>\n";
  function getPageScope(root) {
    return root.closest(".section-content") || document;
  }
  function getToolbarPager(root) {
    return getPageScope(root).querySelector(".toolbar-shop-pager");
  }
  function getFilterGroups(root) {
    return Array.from((root === null || root === void 0 ? void 0 : root.querySelectorAll(FILTER_GROUP_SELECTOR)) || []);
  }
  function hasSingleNonPriceGroup(root) {
    var _filterGroups$;
    var filterGroups = getFilterGroups(root);
    return filterGroups.length === 1 && !((_filterGroups$ = filterGroups[0]) !== null && _filterGroups$ !== void 0 && _filterGroups$.matches(FILTER_PRICE_SELECTOR));
  }
  function isSingleGroupDesktop(root) {
    return Boolean((root === null || root === void 0 ? void 0 : root.classList.contains(SINGLE_GROUP_CLASS)) && DESKTOP_QUERY.matches);
  }
  function isSingleGroupInlineMobile(root) {
    return Boolean((root === null || root === void 0 ? void 0 : root.classList.contains(SINGLE_GROUP_INLINE_MOBILE_CLASS)) && !DESKTOP_QUERY.matches);
  }
  function shouldAutoSubmitSingleGroup(root) {
    return isSingleGroupDesktop(root) || isSingleGroupInlineMobile(root);
  }
  function syncFilterLayout(root) {
    if (!root) {
      return;
    }
    var filterGroupCount = getFilterGroups(root).length;
    var desktopColumns = Math.min(Math.max(filterGroupCount, 1), 3);
    root.style.setProperty("--ad-filters-columns", String(desktopColumns));
    root.classList.toggle(SINGLE_GROUP_CLASS, filterGroupCount === 1);
    root.classList.toggle(SINGLE_GROUP_INLINE_MOBILE_CLASS, hasSingleNonPriceGroup(root));
  }
  function submitFilterForm(root) {
    var form = root === null || root === void 0 ? void 0 : root.querySelector(FILTER_FORM_SELECTOR);
    if (!form || form.dataset.autoSubmitting === "true") {
      return;
    }
    form.dataset.autoSubmitting = "true";
    if (typeof form.requestSubmit === "function") {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event("submit", {
        bubbles: true,
        cancelable: true
      }));
    }
  }
  function scheduleFilterSubmit(root) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 120;
    var form = root === null || root === void 0 ? void 0 : root.querySelector(FILTER_FORM_SELECTOR);
    if (!form || !shouldAutoSubmitSingleGroup(root)) {
      return;
    }
    window.clearTimeout(Number(form.dataset.autoSubmitTimer || 0));
    var timerId = window.setTimeout(function () {
      submitFilterForm(root);
    }, delay);
    form.dataset.autoSubmitTimer = String(timerId);
  }
  function bindSingleGroupAutoSubmit(root) {
    var form = root === null || root === void 0 ? void 0 : root.querySelector(FILTER_FORM_SELECTOR);
    if (!form || form.dataset.singleGroupAutoSubmitBound === "true") {
      return;
    }
    form.dataset.singleGroupAutoSubmitBound = "true";
    form.addEventListener("change", function (event) {
      var target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) {
        return;
      }
      if (!shouldAutoSubmitSingleGroup(root)) {
        return;
      }
      if (target.matches('input[type="checkbox"], input[type="radio"], select')) {
        scheduleFilterSubmit(root);
      }
    });
    form.querySelectorAll("".concat(FILTER_PRICE_SELECTOR, " #slider-range")).forEach(function (slider) {
      $(slider).on("slidestop", function () {
        scheduleFilterSubmit(root, 0);
      });
    });
    form.querySelectorAll("".concat(FILTER_PRICE_SELECTOR, " #min-price-input, ").concat(FILTER_PRICE_SELECTOR, " #max-price-input")).forEach(function (input) {
      input.addEventListener("change", function () {
        scheduleFilterSubmit(root);
      });
      input.addEventListener("blur", function () {
        scheduleFilterSubmit(root);
      });
    });
    form.addEventListener("submit", function () {
      form.dataset.autoSubmitting = "true";
    });
  }
  function setOpenState(root, details, isOpen) {
    if (!root || !details) {
      return;
    }
    details.open = isOpen;
    root.classList.toggle(OPEN_CLASS, isOpen);
    document.body.classList.toggle(BODY_OPEN_CLASS, !DESKTOP_QUERY.matches && isOpen);
  }
  function syncOpenState(root, details) {
    setOpenState(root, details, DESKTOP_QUERY.matches);
  }
  function bindToggle(root, details) {
    var summary = details === null || details === void 0 ? void 0 : details.querySelector("summary");
    if (!details || !summary || details.dataset.filterToggleBound) {
      return;
    }
    details.dataset.filterToggleBound = "true";
    summary.addEventListener("click", function (event) {
      event.preventDefault();
      setOpenState(root, details, !root.classList.contains(OPEN_CLASS));
    });
    details.addEventListener("toggle", function () {
      root.classList.toggle(OPEN_CLASS, details.open);
    });
  }
  function ensureToolbarHost(root) {
    var toolbar = root.querySelector(".ad-filters-toolbar");
    if (!toolbar) {
      toolbar = document.createElement("div");
      toolbar.className = "ad-filters-toolbar";
      root.prepend(toolbar);
    }
    return toolbar;
  }
  function findHeading(root) {
    return getPageScope(root).querySelector(".category-heading-title");
  }
  function ensureHeadingRow(root) {
    var row = root.querySelector(".ad-filters-heading-row");
    if (!row) {
      row = document.createElement("div");
      row.className = "ad-filters-heading-row";
      root.prepend(row);
    }
    return row;
  }
  function ensureDrawerHeader(form) {
    var topAction = form === null || form === void 0 ? void 0 : form.querySelector(".filterActionContainer--top");
    var closeButton = topAction === null || topAction === void 0 ? void 0 : topAction.querySelector(".js-close-filters");
    if (!topAction) {
      return null;
    }
    topAction.classList.add("ad-filters-drawer-heading");
    if (!topAction.querySelector(".ad-filters-drawer-title")) {
      var title = document.createElement("p");
      title.className = "ad-filters-drawer-title";
      title.textContent = "Filtrar por";
      topAction.insertBefore(title, closeButton || null);
    }
    if (closeButton) {
      closeButton.classList.add("ad-filters-drawer-close");
      closeButton.innerHTML = DRAWER_CLOSE_ICON;
    }
    return topAction;
  }
  function ensureDrawerHeaderHost(form) {
    var headerHost = form === null || form === void 0 ? void 0 : form.querySelector(".ad-filters-drawer-header");
    if (!form) {
      return null;
    }
    if (!headerHost) {
      headerHost = document.createElement("div");
      headerHost.className = "ad-filters-drawer-header";
      form.prepend(headerHost);
    }
    return headerHost;
  }
  function relocateButtons(root) {
    var buttons = root.querySelector(".buttons");
    var form = root.querySelector(".filterForm");
    var details = root.querySelector(".filterContent");
    var topAction = ensureDrawerHeader(form);
    var headerHost = ensureDrawerHeaderHost(form);
    if (!buttons || !form) {
      return;
    }
    if (DESKTOP_QUERY.matches) {
      buttons.classList.remove("ad-filters-drawer-applied");
      if (topAction && topAction.parentElement !== form) {
        form.prepend(topAction);
      }
      if (buttons.parentElement !== root || root.querySelector(".buttons") !== buttons) {
        root.insertBefore(buttons, details || form);
      }
      if (headerHost && !headerHost.children.length) {
        headerHost.remove();
      }
      return;
    }
    if (headerHost && topAction) {
      buttons.classList.add("ad-filters-drawer-applied");
      if (topAction.parentElement !== headerHost || headerHost.firstElementChild !== topAction) {
        headerHost.prepend(topAction);
      }
      if (buttons.parentElement !== headerHost || topAction.nextElementSibling !== buttons) {
        headerHost.appendChild(buttons);
      }
      return;
    }
    buttons.classList.add("ad-filters-drawer-applied");
    if (buttons.parentElement !== form || form.firstElementChild !== buttons) {
      form.prepend(buttons);
    }
  }
  function bindDrawerControls(root, details) {
    if (!details || details.dataset.filterDrawerBound) {
      return;
    }
    details.dataset.filterDrawerBound = "true";
    getPageScope(root).querySelectorAll(".filter-backdrop, .close-backdrop-filter, .js-close-filters").forEach(function (control) {
      control.addEventListener("click", function (event) {
        if (DESKTOP_QUERY.matches) {
          return;
        }
        if (control.classList.contains("close-backdrop-filter") || control.classList.contains("js-close-filters")) {
          event.preventDefault();
        }
        setOpenState(root, details, false);
      });
    });
  }
  function handleViewportChange() {
    document.querySelectorAll(FILTER_SELECTOR).forEach(function (root) {
      syncFilterLayout(root);
      relocateButtons(root);
      syncOpenState(root, root.querySelector(".filterContent"));
    });
  }
  function initFilter(root) {
    if (!root || root.dataset.filterLayoutReady) {
      return;
    }
    root.dataset.filterLayoutReady = "true";
    var details = root.querySelector(".filterContent");
    var pager = getToolbarPager(root);
    var toolbar = ensureToolbarHost(root);
    var heading = findHeading(root);
    var headingRow = ensureHeadingRow(root);
    if (heading && heading.parentElement !== headingRow) {
      headingRow.appendChild(heading);
    }
    if (toolbar.parentElement !== headingRow) {
      headingRow.appendChild(toolbar);
    }
    if (pager && pager.parentElement !== toolbar) {
      toolbar.appendChild(pager);
    }
    if (details && details.parentElement !== toolbar) {
      toolbar.appendChild(details);
    }
    syncFilterLayout(root);
    bindSingleGroupAutoSubmit(root);
    relocateButtons(root);
    bindToggle(root, details);
    bindDrawerControls(root, details);
    syncOpenState(root, details);
  }
  function initFilters() {
    document.querySelectorAll(FILTER_SELECTOR).forEach(initFilter);
  }
  (0, _utils.bindMediaChange)(DESKTOP_QUERY, handleViewportChange);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFilters);
  } else {
    initFilters();
  }
});

/***/ }),
/* 3 */
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.bindMediaChange = bindMediaChange;
  _exports.debounceResize = debounceResize;
  _exports.destroySwiper = destroySwiper;
  _exports.getCachedJsonConfig = getCachedJsonConfig;
  _exports.getSwiperState = getSwiperState;
  _exports.mergeDeep = mergeDeep;
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function bindMediaChange(mediaQuery, callback) {
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', callback);
      return;
    }
    mediaQuery.addListener(callback);
  }
  var RESIZE_OVERLAY_SELECTOR = 'dialog[open], .modal.in, .modal.show, [role="dialog"][aria-hidden="false"], [aria-modal="true"][aria-hidden="false"]';
  var SCROLLBAR_RESIZE_TOLERANCE = 24;
  function hasOpenOverlay() {
    return document.body.classList.contains('modal-open') || document.body.classList.contains('drawer-open') || Boolean(document.querySelector(RESIZE_OVERLAY_SELECTOR));
  }
  function debounceResize(callback) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 150;
    var timer = null;
    var lastWidth = window.innerWidth;
    var lastHeight = window.innerHeight;
    function handler() {
      var width = window.innerWidth;
      var height = window.innerHeight;
      var widthDelta = Math.abs(width - lastWidth);
      var heightChanged = height !== lastHeight;
      if (width === lastWidth && !heightChanged) {
        return;
      }
      lastWidth = width;
      lastHeight = height;
      if (!heightChanged && widthDelta <= SCROLLBAR_RESIZE_TOLERANCE && hasOpenOverlay()) {
        return;
      }
      window.clearTimeout(timer);
      timer = window.setTimeout(callback, delay);
    }
    callback();
    if (typeof $ === 'function') {
      $(window).on('resize', handler);
    } else {
      window.addEventListener('resize', handler);
    }
  }
  function getSwiperState($el, key) {
    var state = $el.data(key);
    if (!state) {
      state = {
        swiper: null
      };
      $el.data(key, state);
    }
    return state;
  }
  function getCachedJsonConfig($el, state, defaults, mergeFn) {
    var rawConfig = ($el.attr('data-swiper-config') || '').trim();
    if (state.rawConfig === rawConfig && state.config) {
      return state.config;
    }
    var customConfig = {};
    if (rawConfig) {
      try {
        customConfig = JSON.parse(rawConfig);
      } catch (error) {
        customConfig = {};
      }
    }
    state.rawConfig = rawConfig;
    state.config = mergeFn(defaults, customConfig);
    return state.config;
  }
  function destroySwiper(state) {
    if (!state.swiper) {
      return;
    }
    state.swiper.destroy(true, true);
    state.swiper = null;
  }
  function isPlainObject(value) {
    return Boolean(value) && _typeof(value) === 'object' && !Array.isArray(value);
  }
  function mergeDeep(base, override) {
    if (!isPlainObject(base)) {
      return override;
    }
    if (!isPlainObject(override)) {
      return _objectSpread({}, base);
    }
    var result = _objectSpread({}, base);
    Object.keys(override).forEach(function (key) {
      var baseValue = base[key];
      var overrideValue = override[key];
      result[key] = isPlainObject(baseValue) && isPlainObject(overrideValue) ? mergeDeep(baseValue, overrideValue) : overrideValue;
    });
    return result;
  }
});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_utils) {
  "use strict";

  var REVIEW_SELECTOR = '.module-review-content[data-review-module]';
  var PRODUCT_REVIEW_SELECTOR = '.page-product-product .products-review-content';
  var REVIEW_HEADING_TEXT = 'Quem comprou, recomenda.';
  var REVIEW_HEADING_HTML = 'Quem comprou, <em>recomenda.</em>';
  var REVIEW_SUBTITLE_TEXT = 'Mais de 15 mil pessoas já transformaram suas noites.';
  var REVIEW_PREV_ICON = '' + '<svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' + '<path fill-rule="evenodd" clip-rule="evenodd" d="M-4.53335e-07 5.18555L5.18457 6.4517e-07L6.24512 1.06055L2.87109 4.43555L12.5645 4.43555L12.5645 5.93555L2.87109 5.93555L6.24512 9.30957L5.18457 10.3711L-4.53335e-07 5.18555Z" fill="#192950"/>' + '</svg>';
  var REVIEW_NEXT_ICON = '' + '<svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' + '<path fill-rule="evenodd" clip-rule="evenodd" d="M12.5645 5.18554L7.37988 10.3711L6.31934 9.31055L9.69336 5.93555L1.0378e-06 5.93555L7.75536e-07 4.43555L9.69336 4.43555L6.31934 1.06152L7.37988 -1.29034e-06L12.5645 5.18554Z" fill="#192950"/>' + '</svg>';
  var REVIEW_LINK_ICON = '' + '<svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' + '<path d="M12.5645 5.18555L7.37988 10.3711L6.31934 9.31055L9.69336 5.93555H0V4.43555H9.69336L6.31934 1.06152L7.37988 0L12.5645 5.18555Z" fill="#192950"/>' + '</svg>';
  function getReviewState($module) {
    return (0, _utils.getSwiperState)($module, 'reviewModuleState');
  }
  function getFilledRatingIconClass($module) {
    var $icon = $module.find('.review-rating .mdi').first();
    if ($icon.hasClass('mdi-heart') || $icon.hasClass('mdi-heart-outline')) {
      return 'mdi mdi-heart';
    }
    if ($icon.hasClass('mdi-star') || $icon.hasClass('mdi-star-outline')) {
      return 'mdi mdi-star';
    }
    if ($module.find('.review-rating .fa').length) {
      return 'fa fa-star';
    }
    return 'mdi mdi-star';
  }
  function buildSummaryStars(iconClass) {
    var stars = '';
    for (var index = 0; index < 5; index += 1) {
      stars += '<span class="' + iconClass + '"></span>';
    }
    return stars;
  }
  function formatReviewAverage(value) {
    if (!isFinite(value) || value <= 0) {
      return '0,0/5';
    }
    return value.toFixed(1).replace('.', ',') + '/5';
  }
  function formatReviewTotal(total) {
    if (!isFinite(total) || total <= 0) {
      return 'Com base em 0 avaliações';
    }
    if (total >= 1000) {
      return 'Com base em +' + Math.floor(total / 1000) + ' mil avaliações';
    }
    return 'Com base em +' + new Intl.NumberFormat('pt-BR').format(total) + ' avaliações';
  }
  function buildArrowIcon() {
    return '<span class="ad-review-module__arrow" aria-hidden="true">' + REVIEW_LINK_ICON + '</span>';
  }
  function copyReviewLinkAttributes($source, $target) {
    ['href', 'target', 'rel', 'title', 'data-toggle', 'data-target', 'aria-label'].forEach(function (attribute) {
      var value = $source.attr(attribute);
      if (value) {
        $target.attr(attribute, value);
      }
    });
  }
  function buildNavigationButtons() {
    return '<div class="ad-review-module__navigation">' + '<button type="button" class="ad-review-module__nav ad-review-module__nav--prev" aria-label="Depoimento anterior">' + REVIEW_PREV_ICON + '</button>' + '<button type="button" class="ad-review-module__nav ad-review-module__nav--next" aria-label="Próximo depoimento">' + REVIEW_NEXT_ICON + '</button>' + '</div>';
  }
  function ensureDescriptionStructure($module) {
    var $description = $module.children('.module-review-description').first();
    if (!$description.length) {
      $description = $('<div class="module-review-description"></div>');
      $module.prepend($description);
    }
    var directTextNodes = $description.contents().filter(function () {
      return this.nodeType === 3 && $.trim(this.nodeValue) !== '';
    });
    if (directTextNodes.length) {
      directTextNodes.each(function () {
        $(this).replaceWith('<p>' + $.trim(this.nodeValue) + '</p>');
      });
    }
    var $heading = $description.find('h1, h2, h3, h4, h5, h6').first();
    if (!$heading.length) {
      var $firstParagraph = $description.children('p').first();
      var firstParagraphText = $.trim($firstParagraph.text());
      if (firstParagraphText === REVIEW_HEADING_TEXT) {
        $heading = $('<h2 class="ad-review-module__heading">' + REVIEW_HEADING_HTML + '</h2>');
        $firstParagraph.replaceWith($heading);
      } else {
        $heading = $('<h2 class="ad-review-module__heading">' + REVIEW_HEADING_HTML + '</h2>');
        $description.prepend($heading);
      }
    }
    if (!$description.children('p').length) {
      $description.append('<p>' + REVIEW_SUBTITLE_TEXT + '</p>');
    }
    return $description;
  }
  function normalizeReviewList($list) {
    var element = $list[0];
    if (element && element.swiper) {
      element.swiper.destroy(true, true);
    }
    if ($list.data('owl.carousel')) {
      $list.trigger('destroy.owl.carousel');
    }
    var $baseWrapper = $list.children('.swiper-wrapper');
    if ($baseWrapper.length) {
      $baseWrapper.children('.item').appendTo($list);
      $baseWrapper.remove();
    }
    var $owlStage = $list.find('> .owl-stage-outer > .owl-stage');
    if ($owlStage.length) {
      $owlStage.children('.owl-item').each(function () {
        var $item = $(this).children('.item').first();
        if ($item.length) {
          $item.appendTo($list);
        }
      });
    }
    $list.find('> .owl-stage-outer, > .owl-nav, > .owl-dots, > .navigation, > .swiper-pagination').remove();
    $list.removeClass('owl-carousel owl-theme owl-loaded owl-drag');
    $list.find('.owl-item').remove();
    $list.removeAttr('style');
    $list.wrapInner('<div class="swiper-wrapper"></div>');
    $list.addClass('swiper');
    $list.children('.swiper-wrapper').removeAttr('style');
    $list.children('.swiper-wrapper').children('.item').removeAttr('style').removeClass('active center cloned').addClass('swiper-slide');
  }
  function enhanceReviewCards($module) {
    $module.find('[data-review-item]').each(function () {
      var $item = $(this);
      var thumb = ($item.attr('data-review-thumb') || '').trim();
      var productName = ($item.attr('data-review-product-name') || '').trim();
      var link = ($item.attr('data-review-link') || '').trim();
      var linkLabel = ($item.attr('data-review-link-label') || '').trim();
      var linkTarget = ($item.attr('data-review-link-target') || '_self').trim();
      var footerLabel = productName || linkLabel;
      $item.addClass('ad-review-module__card');
      $item.find('.review-link').addClass('ad-review-module__legacy-link');
      if (thumb && !$item.children('.ad-review-module__thumb').length) {
        var thumbMarkup = '' + '<div class="ad-review-module__thumb">' + '<img src="' + thumb + '" alt="" loading="lazy" decoding="async">' + '</div>';
        $item.find('.review-text').first().after(thumbMarkup);
      }
      if (!$item.children('.ad-review-module__footer').length && footerLabel) {
        var footerTag = link ? 'a' : 'div';
        var $footer = $('<' + footerTag + ' class="ad-review-module__footer"></' + footerTag + '>');
        var $footerLabel = $('<span class="ad-review-module__footer-label"></span>');
        if (link) {
          $footer.attr('href', link);
          if (linkTarget === '_blank') {
            $footer.attr({
              target: '_blank',
              rel: 'noopener noreferrer'
            });
          }
        }
        $footerLabel.text(footerLabel);
        $footer.append($footerLabel);
        $footer.append(buildArrowIcon());
        $item.append($footer);
      }
    });
  }
  function buildModuleLayout($module) {
    if ($module.data('reviewEnhancedLayout')) {
      return;
    }
    if ($module.find('.review_background_image').length) {
      return;
    }
    var $listContainer = $module.find('[data-review-track-container]').first();
    var $list = $module.find('[data-review-list]').first();
    if (!$listContainer.length || !$list.length) {
      return;
    }
    var $description = ensureDescriptionStructure($module);
    var average = parseFloat($module.attr('data-review-average')) || 0;
    var total = parseInt($module.attr('data-review-total'), 10) || 0;
    var reviewsUrl = ($module.attr('data-review-url') || '').trim();
    var filledIconClass = getFilledRatingIconClass($module);
    var $layout = $('<div class="ad-review-module__layout"></div>');
    var $aside = $('<aside class="ad-review-module__aside"></aside>');
    var $summary = $('<div class="ad-review-module__summary">' + '<div class="ad-review-module__summary-row">' + '<strong class="ad-review-module__summary-score">' + formatReviewAverage(average) + '</strong>' + '<div class="ad-review-module__summary-stars" aria-hidden="true">' + buildSummaryStars(filledIconClass) + '</div>' + '</div>' + '<p class="ad-review-module__summary-copy">' + formatReviewTotal(total) + '</p>' + '</div>');
    var $actions = $('<div class="ad-review-module__actions"></div>');
    var $carouselShell = $('<div class="ad-review-module__carousel-shell"></div>');
    var $pagination = $('<div class="ad-review-module__pagination"></div>');
    $module.addClass('ad-review-module');
    if ($description.length) {
      $aside.append($description);
    }
    $aside.append($summary);
    if (reviewsUrl) {
      var $cta = $('<a class="ad-review-module__cta"></a>');
      $cta.attr('href', reviewsUrl);
      $cta.append('<span>Ver mais avaliações</span>');
      $actions.append($cta);
    }
    $actions.append(buildNavigationButtons());
    $aside.append($actions);
    $carouselShell.append($listContainer);
    $carouselShell.append($pagination);
    $layout.append($aside);
    $layout.append($carouselShell);
    $module.append($layout);
    $module.children('.offset-top-20').remove();
    $module.data('reviewEnhancedLayout', true);
  }
  function initReviewSwiper($module) {
    var state = getReviewState($module);
    var $list = $module.find('[data-review-list]').first();
    var $pagination = $module.find('.ad-review-module__pagination').first();
    var $nextButton = $module.find('.ad-review-module__nav--next').first();
    var $prevButton = $module.find('.ad-review-module__nav--prev').first();
    var shouldAutoplay = parseInt($module.attr('data-review-autoplay'), 10) === 1;
    (0, _utils.destroySwiper)(state);
    if (!$list.length || typeof Swiper !== 'function') {
      return;
    }
    normalizeReviewList($list);
    state.swiper = new Swiper($list[0], {
      slidesPerView: 1.15,
      spaceBetween: 16,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 16,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        nextEl: $nextButton[0],
        prevEl: $prevButton[0]
      },
      pagination: {
        el: $pagination[0],
        clickable: true
      },
      autoplay: shouldAutoplay ? {
        delay: 3000,
        disableOnInteraction: true
      } : false,
      breakpoints: {
        768: {
          slidesPerView: 2.2,
          slidesOffsetAfter: 0
        },
        1200: {
          slidesPerView: 3,
          slidesOffsetAfter: 0
        }
      }
    });
  }
  function initReviewModule($module) {
    buildModuleLayout($module);
    enhanceReviewCards($module);
    initReviewSwiper($module);
  }
  function getProductReviewSummary($section) {
    var $summaryData = $section.find('[data-product-review-summary]').first();
    return {
      average: parseFloat($summaryData.attr('data-review-average')) || 0,
      total: parseInt($summaryData.attr('data-review-total'), 10) || 0,
      hasReviews: parseInt($summaryData.attr('data-review-has-reviews'), 10) === 1
    };
  }
  function ensureProductReviewDescriptionStructure() {
    return $('<div class="module-review-description">' + '<h2 class="ad-review-module__heading">' + REVIEW_HEADING_HTML + '</h2>' + '<p>' + REVIEW_SUBTITLE_TEXT + '</p>' + '</div>');
  }
  function enhanceProductReviewCards($module) {
    $module.find('.reviews-list .item').each(function () {
      var $item = $(this);
      var $link = $item.find('.review-link a').first();
      var $firstLabel = $link.find('span').first();
      var footerLabel = $.trim($firstLabel.text()) || 'Ver produto';
      var href = ($link.attr('href') || '').trim();
      $item.addClass('ad-review-module__card');
      $item.find('.review-link').addClass('ad-review-module__legacy-link');
      if (!$item.children('.ad-review-module__footer').length && href) {
        var $footer = $('<a class="ad-review-module__footer"></a>');
        var $footerLabel = $('<span class="ad-review-module__footer-label"></span>');
        $footer.attr('href', href);
        $footerLabel.text(footerLabel);
        $footer.append($footerLabel);
        $footer.append(buildArrowIcon());
        $item.append($footer);
      }
    });
  }
  function buildProductReviewLayout($section) {
    if ($section.data('reviewEnhancedLayout')) {
      return;
    }
    var $container = $section.children('.container').first();
    var $row = $container.find('#reviews').first();
    var $links = $row.find('#review-links').first();
    var $galleryTrigger = $row.find('.reviews-gallery-image').first();
    var $listContainer = $row.find('#review').first();
    var $list = $listContainer.find('.reviews-list').first();
    var $summaryData = $listContainer.find('[data-product-review-summary]').first();
    if (!$container.length || !$row.length || !$listContainer.length || !$list.length && !$summaryData.length) {
      return;
    }
    var reviewSummary = getProductReviewSummary($section);
    var average = reviewSummary.average;
    var total = reviewSummary.total;
    var hasReviews = reviewSummary.hasReviews && $list.length;
    var filledIconClass = getFilledRatingIconClass($section);
    var reviewsUrl = ($links.find('#all-comments-link').attr('href') || '').trim();
    var $writeReviewLink = $links.find('#write-comment-link').first();
    var $description = ensureProductReviewDescriptionStructure();
    var $layout = $('<div class="ad-review-module__layout"></div>');
    var $aside = $('<aside class="ad-review-module__aside"></aside>');
    var $summary = $('<div class="ad-review-module__summary"></div>');
    var $actions = $('<div class="ad-review-module__actions"></div>');
    var $carouselShell = $('<div class="ad-review-module__carousel-shell"></div>');
    var $pagination = $('<div class="ad-review-module__pagination"></div>');
    $section.addClass('ad-review-module ad-review-module--product');
    $listContainer.attr('data-review-track-container', '');
    if ($list.length) {
      $list.attr('data-review-list', '');
    }
    $aside.append($description);
    if (hasReviews) {
      $summary.append('<div class="ad-review-module__summary-row">' + '<strong class="ad-review-module__summary-score">' + formatReviewAverage(average) + '</strong>' + '<div class="ad-review-module__summary-stars" aria-hidden="true">' + buildSummaryStars(filledIconClass) + '</div>' + '</div>');
      var $summaryCopy = $('<p class="ad-review-module__summary-copy"></p>');
      $summaryCopy.text(formatReviewTotal(total));
      if ($writeReviewLink.length) {
        var $writeLink = $('<a class="ad-review-module__product-link ad-review-module__product-link--inline"></a>');
        copyReviewLinkAttributes($writeReviewLink, $writeLink);
        $writeLink.attr('href', $writeLink.attr('href') || 'javascript:void(0)');
        $writeLink.text($.trim($writeReviewLink.text()));
        $summaryCopy.append(' ');
        $summaryCopy.append($writeLink);
      }
      $summary.append($summaryCopy);
      $aside.append($summary);
    }
    if (hasReviews && reviewsUrl) {
      var $cta = $('<a class="ad-review-module__cta"></a>');
      $cta.attr('href', reviewsUrl);
      $cta.append('<span>Ver mais avaliações</span>');
      $actions.append($cta);
    } else if (!hasReviews && $writeReviewLink.length) {
      var _$cta = $('<a class="ad-review-module__cta"></a>');
      copyReviewLinkAttributes($writeReviewLink, _$cta);
      _$cta.attr('href', _$cta.attr('href') || 'javascript:void(0)');
      _$cta.append('<span>Escrever avaliação</span>');
      $actions.append(_$cta);
    }
    if (hasReviews) {
      $actions.append(buildNavigationButtons());
    }
    $aside.append($actions);
    if ($galleryTrigger.length) {
      $galleryTrigger.addClass('ad-review-module__gallery-trigger');
      $carouselShell.append($galleryTrigger);
    }
    $carouselShell.append($listContainer);
    $carouselShell.append($pagination);
    $layout.append($aside);
    $layout.append($carouselShell);
    $container.empty().append($layout);
    $section.data('reviewEnhancedLayout', true);
  }
  function getProductReviewScrollTarget() {
    var $productSection = $('.page-product-product .products-review-content').first();
    if (!$productSection.length) {
      return $();
    }
    return $productSection.find('#reviews-title').first().length ? $productSection.find('#reviews-title').first() : $productSection.find('#reviews').first().length ? $productSection.find('#reviews').first() : $productSection;
  }
  function scrollToProductReviews() {
    var $section = $('.page-product-product .products-review-content').first();
    var $target = getProductReviewScrollTarget();
    if (!$target.length) {
      return;
    }
    $('html, body').stop(true).animate({
      scrollTop: Math.max(($section.length ? $section.offset().top : $target.offset().top) - 96, 0)
    }, 250);
  }
  function bindProductReviewScrollTrigger() {
    var $triggers = $('.page-product-product .product-review-count > span');
    if (!$triggers.length) {
      return;
    }
    $triggers.removeAttr('onclick').attr('role', 'button').attr('tabindex', '0').addClass('ad-product-review-scroll-trigger');
    $(document).off('.adProductReviewScroll').on('click.adProductReviewScroll', '.ad-product-review-scroll-trigger', function (event) {
      event.preventDefault();
      scrollToProductReviews();
    }).on('keydown.adProductReviewScroll', '.ad-product-review-scroll-trigger', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }
      event.preventDefault();
      scrollToProductReviews();
    });
  }
  function initProductReviewSwiper($section) {
    var state = getReviewState($section);
    var $list = $section.find('[data-review-list]').first();
    var $pagination = $section.find('.ad-review-module__pagination').first();
    var $nextButton = $section.find('.ad-review-module__nav--next').first();
    var $prevButton = $section.find('.ad-review-module__nav--prev').first();
    (0, _utils.destroySwiper)(state);
    if (!$list.length || typeof Swiper !== 'function') {
      return;
    }
    normalizeReviewList($list);
    state.swiper = new Swiper($list[0], {
      slidesPerView: 1.15,
      spaceBetween: 16,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 16,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        nextEl: $nextButton[0],
        prevEl: $prevButton[0]
      },
      pagination: {
        el: $pagination[0],
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: 2.2,
          slidesOffsetAfter: 0
        },
        1200: {
          slidesPerView: 3,
          slidesOffsetAfter: 0
        }
      }
    });
  }
  function initProductReviewModule($section) {
    buildProductReviewLayout($section);
    enhanceProductReviewCards($section);
    initProductReviewSwiper($section);
  }
  function initReviewModules() {
    bindProductReviewScrollTrigger();
    $(REVIEW_SELECTOR).each(function () {
      initReviewModule($(this));
    });
    $(PRODUCT_REVIEW_SELECTOR).each(function () {
      var $section = $(this);
      if (!$section.find('#review .reviews-list, #review [data-product-review-summary]').length) {
        return;
      }
      initProductReviewModule($section);
    });
  }
  $(function () {
    (0, _utils.debounceResize)(initReviewModules);
  });
});

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_utils) {
  "use strict";

  var SLEEP_BENEFITS_SELECTOR = '.ad-sleep-benefits';
  var SLEEP_BENEFITS_DEFAULTS = {
    enabledUntil: 1199,
    swiper: {
      slidesPerView: 1.14,
      spaceBetween: 32,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 16,
      grabCursor: true,
      watchOverflow: true,
      loop: false,
      breakpoints: {
        768: {
          slidesPerView: 2.2,
          spaceBetween: 32,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        992: {
          slidesPerView: 3.2,
          spaceBetween: 32,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        }
      }
    }
  };
  function initSleepBenefitsModule($module) {
    var state = (0, _utils.getSwiperState)($module, 'sleepBenefitsState');
    var element = $module.find('.ad-sleep-benefits__carousel')[0];
    var config = (0, _utils.getCachedJsonConfig)($module, state, SLEEP_BENEFITS_DEFAULTS, _utils.mergeDeep);
    (0, _utils.destroySwiper)(state);
    if (window.innerWidth > config.enabledUntil) {
      return;
    }
    if (!element || !element.querySelector('.swiper-slide') || typeof Swiper !== 'function') {
      return;
    }
    state.swiper = new Swiper(element, config.swiper);
  }
  function initSleepBenefitsModules() {
    $(SLEEP_BENEFITS_SELECTOR).each(function () {
      initSleepBenefitsModule($(this));
    });
  }
  $(function () {
    (0, _utils.debounceResize)(initSleepBenefitsModules);
  });
});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_utils) {
  "use strict";

  var SLEEP_STEPS_SELECTOR = '.ad-sleep-steps';
  var SLEEP_STEPS_DEFAULTS = {
    enabledUntil: 1499,
    autoplayOnlyWhenMultipleSlides: true,
    swiper: {
      cssMode: true,
      slidesPerView: 'auto',
      spaceBetween: 48,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      grabCursor: true,
      loop: false,
      watchOverflow: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      breakpoints: {
        768: {
          spaceBetween: 80,
          slidesOffsetAfter: 0
        }
      }
    }
  };
  function initSleepStepsModule($module) {
    var state = (0, _utils.getSwiperState)($module, 'sleepStepsState');
    var element = $module.find('.ad-sleep-steps__carousel')[0];
    var slideCount = element ? element.querySelectorAll('.swiper-slide').length : 0;
    var config = (0, _utils.getCachedJsonConfig)($module, state, SLEEP_STEPS_DEFAULTS, _utils.mergeDeep);
    (0, _utils.destroySwiper)(state);
    if (window.innerWidth > config.enabledUntil) {
      return;
    }
    if (!element || !element.querySelector('.swiper-slide') || typeof Swiper !== 'function') {
      return;
    }
    var swiperConfig = (0, _utils.mergeDeep)(config.swiper, {});
    if (config.autoplayOnlyWhenMultipleSlides && slideCount <= 1) {
      swiperConfig.autoplay = false;
    }
    state.swiper = new Swiper(element, swiperConfig);
  }
  function initSleepStepsModules() {
    $(SLEEP_STEPS_SELECTOR).each(function () {
      initSleepStepsModule($(this));
    });
  }
  $(function () {
    (0, _utils.debounceResize)(initSleepStepsModules);
  });
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_utils) {
  "use strict";

  var DEEPSTATE_MODULE_SELECTOR = '.ad-deepstate-module';
  var DEEPSTATE_TRIGGER_SELECTOR = '.ad-deepstate-module__trigger';
  var DEEPSTATE_PANEL_SELECTOR = '.ad-deepstate-module__panel';
  var DEEPSTATE_PLAYER_SELECTOR = '.ad-deepstate-module__player';
  var DEEPSTATE_VIDEO_SELECTOR = '.ad-deepstate-module__video';
  var DEEPSTATE_OPEN_CLASS = 'is-open';
  var DEEPSTATE_ANIMATING_CLASS = 'is-animating';
  function setDeepstatePanelHeight($panel, height) {
    $panel.css('max-height', "".concat(height, "px"));
  }
  function closeDeepstateItem($item) {
    var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var $trigger = $item.find(DEEPSTATE_TRIGGER_SELECTOR).first();
    var $panel = $item.find(DEEPSTATE_PANEL_SELECTOR).first();
    if (!$trigger.length || !$panel.length || !$item.hasClass(DEEPSTATE_OPEN_CLASS)) {
      return;
    }
    $trigger.attr('aria-expanded', 'false');
    $item.removeClass(DEEPSTATE_OPEN_CLASS);
    if (immediate) {
      $panel.prop('hidden', true).removeClass(DEEPSTATE_ANIMATING_CLASS).css('max-height', '0px');
      return;
    }
    setDeepstatePanelHeight($panel, $panel[0].scrollHeight);
    $panel.addClass(DEEPSTATE_ANIMATING_CLASS);
    window.requestAnimationFrame(function () {
      setDeepstatePanelHeight($panel, 0);
    });
    $panel.one('transitionend', function (event) {
      if (event.originalEvent && event.originalEvent.propertyName !== 'max-height') {
        return;
      }
      $panel.prop('hidden', true).removeClass(DEEPSTATE_ANIMATING_CLASS).css('max-height', '0px');
    });
  }
  function openDeepstateItem($item) {
    var $trigger = $item.find(DEEPSTATE_TRIGGER_SELECTOR).first();
    var $panel = $item.find(DEEPSTATE_PANEL_SELECTOR).first();
    if (!$trigger.length || !$panel.length) {
      return;
    }
    $item.siblings(".".concat(DEEPSTATE_OPEN_CLASS)).each(function () {
      closeDeepstateItem($(this));
    });
    $trigger.attr('aria-expanded', 'true');
    $item.addClass(DEEPSTATE_OPEN_CLASS);
    $panel.prop('hidden', false).addClass(DEEPSTATE_ANIMATING_CLASS).css('max-height', '0px');
    var panelHeight = $panel[0].scrollHeight;
    window.requestAnimationFrame(function () {
      setDeepstatePanelHeight($panel, panelHeight);
    });
    $panel.one('transitionend', function (event) {
      if (event.originalEvent && event.originalEvent.propertyName !== 'max-height') {
        return;
      }
      $panel.removeClass(DEEPSTATE_ANIMATING_CLASS).css('max-height', 'none');
    });
  }
  function syncDeepstatePanels($module) {
    $module.find(".ad-deepstate-module__item.".concat(DEEPSTATE_OPEN_CLASS)).each(function () {
      var $panel = $(this).find(DEEPSTATE_PANEL_SELECTOR).first();
      if (!$panel.length) {
        return;
      }
      $panel.prop('hidden', false).css('max-height', 'none');
    });
  }
  function createDeepstateIframe(videoId) {
    var iframe = document.createElement('iframe');
    iframe.src = "https://www.youtube-nocookie.com/embed/".concat(videoId, "?autoplay=1&rel=0&playsinline=1");
    iframe.title = 'Video sobre a tecnologia Deepstate';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.loading = 'eager';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    return iframe;
  }
  function initDeepstatePlayer($module) {
    var $player = $module.find(DEEPSTATE_PLAYER_SELECTOR).first();
    var $video = $module.find(DEEPSTATE_VIDEO_SELECTOR).first();
    var videoId = ($module.find('.ad-deepstate-module__media').data('videoId') || '').toString().trim();
    if (!$player.length || !$video.length || !videoId || $module.data('deepstatePlayerReady')) {
      return;
    }
    $module.data('deepstatePlayerReady', true);
    $player.on('click', function () {
      if ($module.data('deepstateVideoLoaded')) {
        return;
      }
      $module.data('deepstateVideoLoaded', true);
      $video.empty().append(createDeepstateIframe(videoId)).prop('hidden', false);
      $player.prop('hidden', true);
    });
  }
  function initDeepstateTechnologyModules() {
    $(DEEPSTATE_MODULE_SELECTOR).each(function () {
      var $module = $(this);
      if ($module.data('deepstateTechnologyReady')) {
        syncDeepstatePanels($module);
        initDeepstatePlayer($module);
        return;
      }
      $module.data('deepstateTechnologyReady', true);
      $module.find(DEEPSTATE_PANEL_SELECTOR).each(function () {
        $(this).prop('hidden', true).css('max-height', '0px');
      });
      $module.on('click', DEEPSTATE_TRIGGER_SELECTOR, function () {
        var $item = $(this).closest('.ad-deepstate-module__item');
        if ($item.hasClass(DEEPSTATE_OPEN_CLASS)) {
          closeDeepstateItem($item);
          return;
        }
        openDeepstateItem($item);
      });
      initDeepstatePlayer($module);
    });
  }
  $(function () {
    (0, _utils.debounceResize)(initDeepstateTechnologyModules);
  });
});

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_utils) {
  "use strict";

  var HOME_NEWS_SELECTOR = '.ad-home-news';
  var HOME_NEWS_DEFAULTS = {
    autoplayOnlyWhenMultipleSlides: true,
    swiper: {
      slidesPerView: 1,
      spaceBetween: 16,
      grabCursor: true,
      rewind: true,
      watchOverflow: false,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 16
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 16
        },
        1440: {
          slidesPerView: 4,
          spaceBetween: 16
        }
      }
    }
  };
  function initHomeNewsModule($module) {
    var state = (0, _utils.getSwiperState)($module, 'homeNewsState');
    var element = $module.find('.ad-home-news__carousel')[0];
    var next = $module.find('.ad-home-news__nav--next')[0];
    var prev = $module.find('.ad-home-news__nav--prev')[0];
    var pagination = $module.find('.ad-home-news__pagination')[0];
    var config = (0, _utils.getCachedJsonConfig)($module, state, HOME_NEWS_DEFAULTS, _utils.mergeDeep);
    (0, _utils.destroySwiper)(state);
    var slideCount = element ? element.querySelectorAll('.swiper-slide').length : 0;
    if (!element || !element.querySelector('.swiper-slide') || typeof Swiper !== 'function') {
      return;
    }
    var swiperConfig = (0, _utils.mergeDeep)(config.swiper, {
      navigation: {
        nextEl: next,
        prevEl: prev
      },
      pagination: {
        el: pagination,
        clickable: true
      }
    });
    if (config.autoplayOnlyWhenMultipleSlides && slideCount <= 1) {
      swiperConfig.autoplay = false;
    }
    state.swiper = new Swiper(element, swiperConfig);
  }
  function initHomeNewsModules() {
    $(HOME_NEWS_SELECTOR).each(function () {
      initHomeNewsModule($(this));
    });
  }
  $(function () {
    (0, _utils.debounceResize)(initHomeNewsModules);
  });
});

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(10), __webpack_require__(11), __webpack_require__(12), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_number_formatter, _toast, _loader, _utils) {
  "use strict";

  function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
  function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
  function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
  function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
  function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
  function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
  function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
  function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
  function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
  function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
  function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
  function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
  function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  var BUY_TOGETHER_SELECTOR = ".product-buy-together";
  var BUY_TOGETHER_MOBILE_QUERY = "(max-width: 1023px)";
  var BUY_TOGETHER_OPTIONS_ROUTE = "index.php?route=checkout/cart/getBtOptions&product_id=";
  var BUY_TOGETHER_BREAKPOINTS = {
    0: {
      slidesPerView: 1.2,
      spaceBetween: 12,
      slidesOffsetAfter: 16
    },
    640: {
      slidesPerView: 2.2,
      spaceBetween: 16,
      slidesOffsetAfter: 16
    },
    900: {
      slidesPerView: 3.2,
      spaceBetween: 16,
      slidesOffsetAfter: 16
    }
  };
  function getSectionState(section) {
    if (!section.__buyTogetherState) {
      section.__buyTogetherState = {
        swiper: null
      };
    }
    return section.__buyTogetherState;
  }
  function parseCurrencyValue(rawValue) {
    if (rawValue === null || rawValue === undefined) {
      return 0;
    }
    var normalized = String(rawValue).trim().replace(/\s+/g, "").replace(/[^\d,.-]/g, "").replace(/\.(?=\d{3}(?:\D|$))/g, "").replace(",", ".");
    var parsed = Number.parseFloat(normalized);
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  function placeBuyTogetherSection(section) {
    var productContainer = document.querySelector("#product");
    if (!productContainer) {
      return null;
    }
    var shippingGroup = productContainer.querySelector(".product-shop-content");
    if (shippingGroup) {
      shippingGroup.insertAdjacentElement("afterend", section);
      return productContainer;
    }
    productContainer.append(section);
    return productContainer;
  }
  function getMainProductPrice(section) {
    var productContainer = document.querySelector("#product");
    if (!productContainer) {
      return parseCurrencyValue(section.dataset.mainPrice);
    }
    var currentPriceElement = productContainer.querySelector(".product-price-new") || productContainer.querySelector(".product-main-price");
    return currentPriceElement ? parseCurrencyValue(currentPriceElement.textContent) : parseCurrencyValue(section.dataset.mainPrice);
  }
  function getOptionalProductTotal(item) {
    var basePrice = parseCurrencyValue(item.dataset.specialPrice || item.dataset.price);
    var optionFields = item.querySelectorAll(".product-buy-together__option");
    return Array.from(optionFields).reduce(function (total, field) {
      var selectedOption = field.tagName === "SELECT" ? field.selectedOptions[0] : null;
      var optionPrice = parseCurrencyValue((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.dataset.optionPrice) || 0);
      var optionPrefix = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.dataset.optionPricePrefix) || "+";
      if (!optionPrice) {
        return total;
      }
      return optionPrefix === "-" ? total - optionPrice : total + optionPrice;
    }, basePrice);
  }
  function syncSelectionState(item) {
    var checkbox = item.querySelector(".product-buy-together__checkbox");
    if (!checkbox) {
      return;
    }
    item.classList.toggle("is-selected", checkbox.checked);
  }
  function updateOptionalItemPrice(section, item) {
    var installmentCount = Number(section.dataset.parcelNumber || 1);
    var interestText = section.dataset.interestText || "";
    var total = getOptionalProductTotal(item);
    var priceElement = item.querySelector(".product-buy-together__value");
    var installmentElement = item.querySelector(".product-buy-together__installment");
    if (priceElement) {
      priceElement.textContent = (0, _number_formatter.numberFormatToCurrency)(total);
    }
    if (installmentElement) {
      var installmentValue = installmentCount ? total / installmentCount : total;
      installmentElement.textContent = "".concat(installmentCount, "x de ").concat((0, _number_formatter.numberFormatToCurrency)(installmentValue)) + (interestText ? " ".concat(interestText) : "");
    }
  }
  function getCheckedItems(section) {
    return Array.from(section.querySelectorAll(".product-buy-together__checkbox:checked")).map(function (checkbox) {
      return checkbox.closest(".product-buy-together__item");
    });
  }
  function getMainProductFormFields(section) {
    var productForm = document.querySelector("#product");
    if (!productForm) {
      return [];
    }
    return Array.from(productForm.querySelectorAll('input[name^="option["], select[name^="option["], textarea[name^="option["]')).filter(function (field) {
      return !field.closest(BUY_TOGETHER_SELECTOR);
    });
  }
  function getScrollTarget(element) {
    if (!element) {
      return null;
    }
    return element.closest(".form-group") || element.closest(".product-options-list") || element.closest(".options-list") || element.closest(".product-size-content") || element.closest(".option-group") || element;
  }
  function scrollToElement(element) {
    var target = getScrollTarget(element);
    if (!target || typeof target.scrollIntoView !== "function") {
      return;
    }
    target.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  }
  function focusMainProduct(section) {
    var _section$querySelecto;
    var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var productRoot = document.querySelector("#product");
    var scrollTarget = field || productRoot;
    scrollToElement(scrollTarget);
    if (field && typeof field.focus === "function" && field.type !== "hidden") {
      window.setTimeout(function () {
        field.focus({
          preventScroll: true
        });
      }, 250);
    }
    (_section$querySelecto = section.querySelector(".product-buy-together__add-to-cart")) === null || _section$querySelecto === void 0 || _section$querySelecto.blur();
  }
  function updateSummary(section) {
    var totalValueElement = section.querySelector(".product-buy-together__summary-value");
    var parcelValueElement = section.querySelector(".product-buy-together__summary-installment");
    var installmentCount = Number(section.dataset.parcelNumber || 1);
    var installmentInterest = parseCurrencyValue(section.dataset.parcelInterest);
    var interestText = section.dataset.interestText || "";
    var total = getCheckedItems(section).reduce(function (sum, item) {
      if (!item) {
        return sum;
      }
      return sum + getOptionalProductTotal(item);
    }, getMainProductPrice(section));
    var installmentValue = installmentCount ? total / installmentCount + total * (installmentInterest / 100) : total;
    if (totalValueElement) {
      totalValueElement.textContent = (0, _number_formatter.numberFormatToCurrency)(total);
    }
    if (parcelValueElement) {
      parcelValueElement.textContent = "".concat(installmentCount, "x de ").concat((0, _number_formatter.numberFormatToCurrency)(installmentValue)) + (interestText ? " ".concat(interestText) : "");
    }
  }
  function hasStockOptions(item) {
    return (item === null || item === void 0 ? void 0 : item.dataset.hasStockOptions) === "1";
  }
  function mapModalOptionsToItem(section, item, modalBody) {
    var productId = item.dataset.productId;
    var optionFields = modalBody.querySelectorAll('[name^="option["]');
    optionFields.forEach(function (field) {
      var match = field.name.match(/^option\[(\d+)\]$/);
      if (!match) {
        return;
      }
      var optionId = match[1];
      var itemField = item.querySelector("[name=\"option[".concat(productId, "][").concat(optionId, "]\"]"));
      if (!itemField) {
        return;
      }
      itemField.value = field.value;
      itemField.dispatchEvent(new Event("change", {
        bubbles: true
      }));
    });
    updateOptionalItemPrice(section, item);
    updateSummary(section);
  }
  function validateModalOptions(modalBody) {
    var requiredWrappers = modalBody.querySelectorAll(".options-list.required");
    var _iterator = _createForOfIteratorHelper(requiredWrappers),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var wrapper = _step.value;
        var select = wrapper.querySelector("select");
        var hidden = wrapper.querySelector('input[type="hidden"][name^="option["]');
        var text = wrapper.querySelector('input[type="text"][name^="option["], textarea[name^="option["], input[type="date"][name^="option["], input[type="time"][name^="option["], input[type="datetime-local"][name^="option["]');
        var invalid = false;
        if (select) {
          invalid = !select.value || select.value === "0";
        } else if (hidden) {
          invalid = !hidden.value || hidden.value === "0";
        } else if (text) {
          invalid = !text.value;
        }
        wrapper.classList.toggle("has-error", invalid);
        if (invalid) {
          return false;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return true;
  }
  function openOptionsModal(_x, _x2) {
    return _openOptionsModal.apply(this, arguments);
  }
  function _openOptionsModal() {
    _openOptionsModal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(section, item) {
      var modal, modalBody, confirmButton, productId, closed, confirmed, closeModal, response, revealNextOptions, closeButtons, decision, _t;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            modal = section.querySelector("#btOptionSelect");
            modalBody = modal === null || modal === void 0 ? void 0 : modal.querySelector(".product-buy-together__modal-body");
            confirmButton = modal === null || modal === void 0 ? void 0 : modal.querySelector(".product-buy-together__modal-confirm");
            productId = item.dataset.productId;
            if (!(!modal || !modalBody || !confirmButton || !productId)) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2, false);
          case 1:
            closed = false;
            confirmed = false;
            closeModal = function closeModal() {
              if (closed) {
                return;
              }
              closed = true;
              modal.hidden = true;
              document.body.classList.remove("bt-modal-open");
              modalBody.innerHTML = "";
            };
            modalBody.innerHTML = '<div class="product-buy-together__modal-loading" aria-live="polite">Carregando opções...</div>';
            modal.hidden = false;
            document.body.classList.add("bt-modal-open");
            _context3.p = 2;
            _context3.n = 3;
            return fetch("".concat(BUY_TOGETHER_OPTIONS_ROUTE).concat(encodeURIComponent(productId)), {
              headers: {
                "X-Requested-With": "XMLHttpRequest"
              }
            });
          case 3:
            response = _context3.v;
            if (response.ok) {
              _context3.n = 4;
              break;
            }
            throw new Error("Falha ao carregar op\xE7\xF5es: ".concat(response.status));
          case 4:
            _context3.n = 5;
            return response.text();
          case 5:
            modalBody.innerHTML = _context3.v;
            _context3.n = 7;
            break;
          case 6:
            _context3.p = 6;
            _t = _context3.v;
            closeModal();
            (0, _toast.createToast)({
              title: "Erro",
              message: "Não foi possível carregar as opções deste produto.",
              type: "error",
              timeout: 8000
            });
            return _context3.a(2, false);
          case 7:
            modalBody.querySelectorAll(".options-list").forEach(function (wrapper, index) {
              if (index > 0) {
                wrapper.style.display = "none";
              }
            });
            revealNextOptions = function revealNextOptions(currentWrapper) {
              var nextWrapper = currentWrapper === null || currentWrapper === void 0 ? void 0 : currentWrapper.nextElementSibling;
              if (!nextWrapper || !nextWrapper.classList.contains("options-list")) {
                return;
              }
              nextWrapper.style.display = "";
            };
            modalBody.querySelectorAll(".sizes").forEach(function (option) {
              option.addEventListener("click", function () {
                var optionId = option.dataset.productOptionId;
                var valueId = option.dataset.productOptionValueId;
                var hidden = modalBody.querySelector("#input-option".concat(optionId));
                var group = option.closest(".product-options-list");
                group === null || group === void 0 || group.querySelectorAll(".sizes.selected").forEach(function (selected) {
                  selected.classList.remove("selected");
                  selected.checked = false;
                });
                option.checked = true;
                option.classList.add("selected");
                if (hidden) {
                  hidden.value = valueId || "";
                }
                revealNextOptions(option.closest(".options-list"));
              });
            });
            modalBody.querySelectorAll(".option_type_select").forEach(function (select) {
              select.addEventListener("change", function () {
                if (select.value === "size_no_available") {
                  select.value = "0";
                  (0, _toast.createToast)({
                    title: "Aviso",
                    message: "A opção selecionada está sem estoque.",
                    type: "warning",
                    timeout: 5000
                  });
                  return;
                }
                revealNextOptions(select.closest(".options-list"));
              });
            });
            closeButtons = modal.querySelectorAll("[data-bt-modal-close]");
            _context3.n = 8;
            return new Promise(function (resolve) {
              closeButtons.forEach(function (button) {
                button.onclick = function () {
                  closeModal();
                  resolve(false);
                };
              });
              confirmButton.onclick = function () {
                if (!validateModalOptions(modalBody)) {
                  (0, _toast.createToast)({
                    title: "Aviso",
                    message: "Alguma das opções obrigatórias não foi selecionada.",
                    type: "warning",
                    timeout: 5000
                  });
                  return;
                }
                confirmed = true;
                mapModalOptionsToItem(section, item, modalBody);
                closeModal();
                resolve(true);
              };
            });
          case 8:
            decision = _context3.v;
            return _context3.a(2, confirmed && decision);
        }
      }, _callee3, null, [[2, 6]]);
    }));
    return _openOptionsModal.apply(this, arguments);
  }
  function buildMainProductData(section) {
    var params = new URLSearchParams();
    var csrfField = document.querySelector("#__csrf");
    params.append("product_id", section.dataset.mainProductId);
    params.append("quantity", "1");
    if (csrfField !== null && csrfField !== void 0 && csrfField.value) {
      params.append("__csrf", csrfField.value);
    }
    getMainProductFormFields(section).forEach(function (field) {
      if (field.disabled || !field.name || field.type === "file") {
        return;
      }
      if ((field.type === "checkbox" || field.type === "radio") && !field.checked) {
        return;
      }
      params.append(field.name, field.value);
    });
    return params;
  }
  function validateMainProduct(section) {
    var fields = getMainProductFormFields(section);
    var invalidFields = [];
    fields.forEach(function (field) {
      if (field.disabled || !field.name) {
        return;
      }
      if ((field.type === "checkbox" || field.type === "radio") && !field.required) {
        return;
      }
      var invalid = false;
      if (field.tagName === "SELECT") {
        invalid = !field.value || field.value === "0" || field.value === "size_no_available";
      } else if (field.type === "checkbox" || field.type === "radio") {
        var group = fields.filter(function (groupField) {
          return groupField.name === field.name;
        });
        invalid = group.length > 0 && !group.some(function (groupField) {
          return groupField.checked;
        });
      } else {
        invalid = !String(field.value || "").trim();
      }
      field.classList.toggle("error", invalid);
      if (invalid && !invalidFields.includes(field)) {
        invalidFields.push(field);
      }
    });
    if (!invalidFields.length) {
      return true;
    }
    (0, _toast.createToast)({
      title: "Erro",
      message: "Selecione as opções obrigatórias do produto principal antes de adicionar o compre junto.",
      type: "error",
      timeout: 8000
    });
    focusMainProduct(section, invalidFields[0]);
    return false;
  }
  function buildOptionalProductData(formData, productId, csrfValue) {
    var params = new URLSearchParams();
    params.append("product_id", productId);
    params.append("quantity", "1");
    if (csrfValue) {
      params.append("__csrf", csrfValue);
    }
    var _iterator2 = _createForOfIteratorHelper(formData.entries()),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = _slicedToArray(_step2.value, 2),
          key = _step2$value[0],
          value = _step2$value[1];
        var match = key.match(/^option\[(\d+)\]\[(\d+)\]$/);
        if (!match) {
          continue;
        }
        var _match = _slicedToArray(match, 3),
          fieldProductId = _match[1],
          optionId = _match[2];
        if (fieldProductId === productId) {
          params.append("option[".concat(optionId, "]"), value);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return params;
  }
  function validateOptionalProducts(section) {
    var invalidProducts = [];
    getCheckedItems(section).forEach(function (item) {
      if (!item) {
        return;
      }
      var requiredFields = item.querySelectorAll(".product-buy-together__option[required]");
      var hasError = Array.from(requiredFields).some(function (field) {
        var invalid = field.value === "" || field.value === "0";
        field.classList.toggle("error", invalid);
        return invalid;
      });
      if (hasError) {
        var _item$querySelector;
        invalidProducts.push(((_item$querySelector = item.querySelector(".product-buy-together__name")) === null || _item$querySelector === void 0 || (_item$querySelector = _item$querySelector.textContent) === null || _item$querySelector === void 0 ? void 0 : _item$querySelector.trim()) || "Produto");
      }
    });
    if (!invalidProducts.length) {
      return true;
    }
    (0, _toast.createToast)({
      title: "Erro",
      message: "Escolha as op\xE7\xF5es obrigat\xF3rias para: ".concat(invalidProducts.join(", "), "."),
      type: "error",
      timeout: 8000
    });
    return false;
  }
  function focusFirstInvalidOptionalProduct(section) {
    var firstInvalidField = section.querySelector(".product-buy-together__option.error");
    if (!firstInvalidField) {
      return;
    }
    scrollToElement(firstInvalidField.closest(".product-buy-together__item"));
  }
  function destroyCarousel(section) {
    var state = getSectionState(section);
    if (!state.swiper) {
      return;
    }
    state.swiper.destroy(true, true);
    state.swiper = null;
  }
  function resetSingleItemLayout(section) {
    var wrapper = section.querySelector(".product-buy-together__track .swiper-wrapper");
    var slide = section.querySelector(".product-buy-together__track .swiper-slide");
    var pagination = section.querySelector(".product-buy-together__pagination");
    section.classList.remove("product-buy-together--single-item");
    if (wrapper) {
      wrapper.style.display = "";
      wrapper.style.transform = "";
    }
    if (slide) {
      slide.style.width = "";
    }
    if (pagination) {
      pagination.style.display = "";
    }
  }
  function applySingleItemLayout(section) {
    var itemCount = section.querySelectorAll(".product-buy-together__item").length;
    var wrapper = section.querySelector(".product-buy-together__track .swiper-wrapper");
    var slide = section.querySelector(".product-buy-together__track .swiper-slide");
    var pagination = section.querySelector(".product-buy-together__pagination");
    resetSingleItemLayout(section);
    if (itemCount > 1 || !window.matchMedia(BUY_TOGETHER_MOBILE_QUERY).matches) {
      return itemCount;
    }
    section.classList.add("product-buy-together--single-item");
    if (wrapper) {
      wrapper.style.display = "block";
      wrapper.style.transform = "none";
    }
    if (slide) {
      slide.style.width = "100%";
    }
    if (pagination) {
      pagination.style.display = "none";
    }
    return itemCount;
  }
  function initCarousel(section) {
    var state = getSectionState(section);
    var track = section.querySelector(".product-buy-together__track");
    var pagination = section.querySelector(".product-buy-together__pagination");
    var itemCount = applySingleItemLayout(section);
    destroyCarousel(section);
    if (!window.matchMedia(BUY_TOGETHER_MOBILE_QUERY).matches) {
      return;
    }
    if (itemCount <= 1) {
      return;
    }
    if (!track || !track.querySelector(".swiper-slide") || typeof Swiper !== "function") {
      return;
    }
    state.swiper = new Swiper(track, {
      slidesPerView: 1.2,
      spaceBetween: 12,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 16,
      grabCursor: true,
      watchOverflow: true,
      breakpoints: BUY_TOGETHER_BREAKPOINTS,
      pagination: {
        el: pagination,
        clickable: true
      }
    });
  }
  function addBuyTogetherToCart(_x3) {
    return _addBuyTogetherToCart.apply(this, arguments);
  }
  function _addBuyTogetherToCart() {
    _addBuyTogetherToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(section) {
      var _document$querySelect;
      var form, csrfValue, formData, selectedOptionalProducts, requestQueue, _iterator3, _step3, _step3$value, index, productData, _json$error, response, json, _json$error2, _t2, _t3;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            form = section.querySelector("#product-buy-together__form");
            if (form) {
              _context4.n = 1;
              break;
            }
            return _context4.a(2);
          case 1:
            csrfValue = ((_document$querySelect = document.querySelector("#__csrf")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.value) || "";
            formData = new FormData(form);
            selectedOptionalProducts = formData.getAll("buy_together_products[]");
            requestQueue = [buildMainProductData(section)].concat(_toConsumableArray(selectedOptionalProducts.map(function (productId) {
              return buildOptionalProductData(formData, productId, csrfValue);
            })));
            (0, _loader.loader)();
            _iterator3 = _createForOfIteratorHelper(requestQueue.entries());
            _context4.p = 2;
            _iterator3.s();
          case 3:
            if ((_step3 = _iterator3.n()).done) {
              _context4.n = 10;
              break;
            }
            _step3$value = _slicedToArray(_step3.value, 2), index = _step3$value[0], productData = _step3$value[1];
            _context4.p = 4;
            _context4.n = 5;
            return fetch("index.php?route=checkout/cart/add", {
              method: "POST",
              headers: {
                "X-Requested-With": "XMLHttpRequest"
              },
              body: productData
            });
          case 5:
            response = _context4.v;
            _context4.n = 6;
            return response.json();
          case 6:
            json = _context4.v;
            if (!(json.error_stock || json.error || (_json$error = json.error) !== null && _json$error !== void 0 && _json$error.login_required)) {
              _context4.n = 7;
              break;
            }
            (0, _toast.createToast)({
              title: "Erro",
              message: json.error_stock || ((_json$error2 = json.error) === null || _json$error2 === void 0 ? void 0 : _json$error2.login_required) || "Confirme se todas as opções dos produtos selecionados estão preenchidas.",
              type: "error",
              timeout: 8000
            });
            if (index === 0) {
              focusMainProduct(section);
            }
            (0, _loader.loader)(false);
            return _context4.a(2, false);
          case 7:
            _context4.n = 9;
            break;
          case 8:
            _context4.p = 8;
            _t2 = _context4.v;
            console.error("Erro ao adicionar produto ao carrinho:", _t2);
            (0, _toast.createToast)({
              title: "Erro",
              message: "Não foi possível adicionar o produto ao carrinho.",
              type: "error",
              timeout: 8000
            });
            (0, _loader.loader)(false);
            return _context4.a(2, false);
          case 9:
            _context4.n = 3;
            break;
          case 10:
            _context4.n = 12;
            break;
          case 11:
            _context4.p = 11;
            _t3 = _context4.v;
            _iterator3.e(_t3);
          case 12:
            _context4.p = 12;
            _iterator3.f();
            return _context4.f(12);
          case 13:
            if (typeof loadQuantityItensCart === "function") {
              loadQuantityItensCart();
            }
            if (typeof loadCartProducts === "function") {
              loadCartProducts();
            }
            (0, _loader.loader)(false);
            window.location.href = "/carrinho";
            return _context4.a(2, true);
        }
      }, _callee4, null, [[4, 8], [2, 11, 12, 13]]);
    }));
    return _addBuyTogetherToCart.apply(this, arguments);
  }
  function bindSection(section) {
    var mainProduct = placeBuyTogetherSection(section);
    var productItems = section.querySelectorAll(".product-buy-together__item");
    var addToCartButton = section.querySelector(".product-buy-together__add-to-cart");
    productItems.forEach(function (item) {
      syncSelectionState(item);
      updateOptionalItemPrice(section, item);
      var checkbox = item.querySelector(".product-buy-together__checkbox");
      var optionFields = item.querySelectorAll(".product-buy-together__option");
      checkbox === null || checkbox === void 0 || checkbox.addEventListener("change", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var selected;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(checkbox.checked && hasStockOptions(item))) {
                _context.n = 2;
                break;
              }
              checkbox.checked = false;
              syncSelectionState(item);
              _context.n = 1;
              return openOptionsModal(section, item);
            case 1:
              selected = _context.v;
              if (selected) {
                checkbox.checked = true;
              }
            case 2:
              syncSelectionState(item);
              updateSummary(section);
            case 3:
              return _context.a(2);
          }
        }, _callee);
      })));
      optionFields.forEach(function (field) {
        field.addEventListener("change", function () {
          if (field.value === "size_no_available") {
            field.value = "0";
            (0, _toast.createToast)({
              title: "Aviso",
              message: "A opção selecionada está sem estoque.",
              type: "warning",
              timeout: 5000
            });
          }
          field.classList.remove("error");
          if (checkbox) {
            checkbox.checked = field.value !== "" && field.value !== "0";
            syncSelectionState(item);
          }
          updateOptionalItemPrice(section, item);
          updateSummary(section);
        });
      });
    });
    mainProduct === null || mainProduct === void 0 || mainProduct.addEventListener("change", function (event) {
      var target = event === null || event === void 0 ? void 0 : event.target;
      if (target instanceof HTMLElement && target.matches('input[name^="option["], select[name^="option["], textarea[name^="option["]')) {
        target.classList.remove("error");
      }
      window.setTimeout(function () {
        return updateSummary(section);
      }, 50);
    });
    addToCartButton === null || addToCartButton === void 0 || addToCartButton.addEventListener("click", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              event.preventDefault();
              if (validateMainProduct(section)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              if (validateOptionalProducts(section)) {
                _context2.n = 2;
                break;
              }
              focusFirstInvalidOptionalProduct(section);
              return _context2.a(2);
            case 2:
              _context2.n = 3;
              return addBuyTogetherToCart(section);
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x4) {
        return _ref2.apply(this, arguments);
      };
    }());
    initCarousel(section);
    updateSummary(section);
  }
  function initBuyTogetherModules() {
    document.querySelectorAll(BUY_TOGETHER_SELECTOR).forEach(function (section) {
      if (!section.dataset.buyTogetherBound) {
        section.dataset.buyTogetherBound = "true";
        bindSection(section);
        return;
      }
      initCarousel(section);
      updateSummary(section);
    });
  }
  document.addEventListener("DOMContentLoaded", function () {
    (0, _utils.debounceResize)(initBuyTogetherModules);
  });
});

/***/ }),
/* 10 */
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.currencyFormatToNumber = currencyFormatToNumber;
  _exports.numberFormatToCurrency = numberFormatToCurrency;
  _exports.numberFormatToString = numberFormatToString;
  _exports.stringFormatToNumber = stringFormatToNumber;
  /**
   * [numberFormatToCurrency] Formatação de numero para moeda
   * @author Eduardo Xavier     <[<eduardo.xavier@irroba.com.br>]>
   * @param  [number] valor       [Numero a ser formatado]
   * @param  [string] moeda       [Moeda a ser utilizada] [BRL, USD, EUR, etc]
   * @param  [string] locale      [Localidade da formatação da casa decimal a ser utilizada] [pt-BR, en-US, etc]
   * @return [string]             [Retorna um valor formatado para moeda] [R$ 1.234,56, $1,234.56, etc]
   */
  function numberFormatToCurrency(valor) {
    var moeda = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "BRL";
    var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "pt-BR";
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: moeda
    }).format(valor);
  }

  /**
   * [currencyFormatToNumber] Formatação de moeda para numero
   * @author Eduardo Xavier     <[<eduardo.xavier@irroba.com.br>]>
   * @param  [string] valorMoeda  [Valor em moeda a ser formatado em numero] [R$ 1.234,56, $1,234.56, etc]
   * @param  [string] locale      [Localidade da formatação da casa decimal a ser utilizada] [pt-BR, en-US, etc]
   * @return [number]             [Retorna o valor formatado em numero] [1234,56, 1234.56, etc]
   */
  function currencyFormatToNumber(valorMoeda) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "pt-BR";
    var exemplo = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: "BRL"
    }).format(1234567.89);

    // Detecta os separadores com base no valor formatado
    var match = exemplo.match(/([\d])([^0-9\s])([\d]{3})[^0-9]*([\d]{2})/);
    if (!match) {
      console.warn("Não foi possível detectar os separadores corretamente.");
      return NaN;
    }
    var separadorMilhar = match[2];
    var separadorDecimal = exemplo.match(/(\d+)(\D)(\d{2})\D*$/)[2];

    // Limpa e converte
    var numeroLimpo = valorMoeda.replace(/[^\d.,-]/g, "") // Remove símbolos de moeda e espaços
    .replace(new RegExp("\\".concat(separadorMilhar), "g"), "") // Remove milhar
    .replace(separadorDecimal, "."); // Substitui decimal por ponto

    return parseFloat(numeroLimpo);
  }

  /**
   * [numberFormatToString] Formatação de numero para string
   * @author Eduardo Xavier     <[<eduardo.xavier@irroba.com.br>]>
   * @param  [number] valor       [Numero a ser formatado] [1.234,56, 1234.56, etc]
   * @param  [string] locale      [Localidade da formatação da casa decimal a ser utilizada] [pt-BR, en-US, etc]
   * @return [string]             [Retorna o valor formatado em string] ['1.234,56', '1,234.56', etc]
   */
  function numberFormatToString(valor) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "pt-BR";
    var casasDecimais = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: casasDecimais,
      maximumFractionDigits: casasDecimais
    }).format(valor);
  }

  /**
   * [stringFormatToNumber] Formatação de string para numero
   * @author Eduardo Xavier       <[<eduardo.xavier@irroba.com.br>]>
   * @param  [string] numeroString [String a ser formatada] ['1.234,56', '1,234.56', etc]
   * @param  [string] locale      [Localidade da formatação da casa decimal a ser utilizada] [pt-BR, en-US, etc]
   * @return [number]             [Retorna o valor formatado em numero] [1234.56, 1.23456, etc]
   */
  function stringFormatToNumber(numeroString) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "pt-BR";
    // Usa um número que força o uso de separador de milhar E decimal
    var exemplo = new Intl.NumberFormat(locale).format(1234567.89);

    // Detecta separador decimal e milhar
    var match = exemplo.match(/1(.?)234(.?)567(.?)89/);
    if (!match) {
      console.warn("Separadores não detectados");
      return NaN;
    }
    var separadorMilhar = match[1];
    var separadorDecimal = match[3];

    // Limpa a string: remove milhar e troca decimal por ponto
    var numeroLimpo = numeroString.replace(new RegExp("\\".concat(separadorMilhar), 'g'), '').replace(separadorDecimal, '.').replace(/[^\d.-]/g, ''); // Remove qualquer símbolo inesperado

    return parseFloat(numeroLimpo);
  }
});

/***/ }),
/* 11 */
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.createToast = createToast;
  /** ANCHOR - Função para gerar toast
   * [createToast - Função gera um pequeno alerta que surge no topo direito da página que some após um tempo]
   * @author Eduardo de Paula Xavier eduardo.xavier@irroba.com.br
   * @objParam  [title: STRING Titulo do alerta]
   * @objParam  [message: STRING Mensagem descritiva do alerta]
   * @objParam  [type: STRING tipo do alerta, apenas success|info|error|warning irão gerar as cores e os ícones desejados ]
   * @objParam  [timeout: NUMBER tempo em ms que o alerta irá ser exibido até que ele desapareça]
   * @return [void: por padrão será mostrado um alerta de confirmação com mensagem e título genéricos]
   */

  function createToast() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Sucesso" : _ref$title,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? "Dados cadastrados com sucesso" : _ref$message,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "success" : _ref$type,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 3000 : _ref$timeout;
    var body = document.querySelector("body");
    var existingDiv = document.getElementById("toastContainer");
    if (!existingDiv) {
      var newDiv = document.createElement("div");
      newDiv.setAttribute("id", "toastContainer");
      newDiv.setAttribute("class", "toast-container");
      body.appendChild(newDiv);
    }
    var toastContainer = document.getElementById("toastContainer");
    var toast = document.createElement("div");
    toast.className = "toast-item";
    toast.innerHTML = "\n        <div class=\"toast-content flex justify-between p-4 gap-2 w-full\">\n          <div class=\"toast-content__icon\">\n            ".concat(getIcon(type), "\n          </div>\n          <div class=\"toast-content__dialog\">\n              <h6 class=\"toast-content__title\">").concat(title, "</h6>\n              <div class=\"toast-content__message\">\n                    <span>").concat(message, "</span>\n                </div>\n          </div>\n          <button role=\"button\" class=\"toast-content__button-close\" onclick=\"window.removeToast(this.closest('.toast-item'))\">\n            <svg xmlns=\"http://www.w3.org/2000/svg\" height=\"1rem\" viewBox=\"0 -960 960 960\" width=\"1rem\" fill=\"#e8eaed\"><path d=\"m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z\"/></svg>\n          </button>\n\n        </div>\n        <div class=\"toast-progress-bar\">\n            <span class=\"toast-progress-bar__percentage toast-progress-bar__percentage--").concat(type, "\" style=\"animation: growRight ").concat(timeout / 1000, "s ease infinite forwards ;\"></span>\n        </div>\n    ");
    toastContainer.appendChild(toast);
    setTimeout(function () {
      window.removeToast(toast);
    }, timeout);
  }
  window.removeToast = function (toast) {
    if (toast.parentNode) {
      toast.parentNode.removeChild(toast);
    }
  };
  function getIcon(type) {
    if (type === "info") {
      return "\n      <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"toast-info\" height=\"24px\" viewBox=\"0 -960 960 960\" width=\"24px\" fill=\"#e8eaed\"><path d=\"M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z\"/></svg>\n      ";
    } else if (type === "success") {
      return "\n        <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"toast-success\" height=\"24px\" viewBox=\"0 -960 960 960\" width=\"24px\" fill=\"#e8eaed\">\n        <path d=\"m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z\"/>\n        </svg>\n          ";
    } else if (type === "warning") {
      return "\n          <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"toast-warning\" height=\"24px\" viewBox=\"0 -960 960 960\" width=\"24px\" fill=\"#e8eaed\"><path d=\"m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm302-40q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Zm40-100Z\"/></svg>\n      ";
    } else if (type === "error") {
      return "\n            <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"toast-error\" height=\"24px\" viewBox=\"0 -960 960 960\" width=\"24px\" fill=\"#e8eaed\"><path d=\"M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z\"/></svg>\n          ";
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.loader = loader;
  function loader() {
    var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var body = document.body;
    var bgLoader = document.getElementById('bgLoader');
    if (bgLoader) {
      bgLoader.remove();
      body.classList.remove('overflow-hidden');
    }
    if (open) {
      var htmlString = "\n        <div class=\"loader-content\" id=\"bgLoader\">\n            <div role=\"status\" class=\"loader-spinner\">\n                <svg aria-hidden=\"true\" class=\"loader-spinner__svg\" viewBox=\"0 0 100 101\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z\" fill=\"currentFill\"/><path d=\"M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z\" fill=\"currentColor\"/></svg>\n                <span class=\"sr-only\">Carregando...</span>\n            </div>\n        </div>\n        ";
      body.insertAdjacentHTML('beforeend', htmlString);
      body.classList.add('overflow-hidden');
    }
  }
});

/***/ }),
/* 13 */
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function () {
  "use strict";

  var CART_BUY_TOGETHER_SELECTOR = "#cart-section-content #buy_together_container";
  var CART_BUY_TOGETHER_BREAKPOINTS = {
    0: {
      slidesPerView: 1.12,
      spaceBetween: 16
    },
    640: {
      slidesPerView: 2.12,
      spaceBetween: 16
    },
    1024: {
      slidesPerView: 3.08,
      spaceBetween: 20
    },
    1440: {
      slidesPerView: 4.14,
      spaceBetween: 20
    }
  };
  function createCartBuyTogetherButton(type) {
    var button = document.createElement("button");
    button.type = "button";
    button.className = "cart-buy-together__nav cart-buy-together__nav--".concat(type);
    button.setAttribute("aria-label", type === "prev" ? "Produto anterior" : "Próximo produto");
    return button;
  }
  function ensureCartBuyTogetherNavigation(container) {
    var navigation = container.querySelector(".cart-buy-together__navigation");
    container.setAttribute("aria-label", "Adicione também à sua compra");
    if (!navigation) {
      navigation = document.createElement("div");
      navigation.className = "cart-buy-together__navigation";
      navigation.append(createCartBuyTogetherButton("prev"));
      navigation.append(createCartBuyTogetherButton("next"));
      container.prepend(navigation);
    }
    return {
      next: navigation.querySelector(".cart-buy-together__nav--next"),
      prev: navigation.querySelector(".cart-buy-together__nav--prev")
    };
  }
  function initCartBuyTogether(container) {
    var swiperElement = container.querySelector(".bt-swiper");
    if (!swiperElement || !swiperElement.querySelector(".swiper-slide") || typeof Swiper !== "function") {
      return;
    }
    var navigation = ensureCartBuyTogetherNavigation(container);
    if (swiperElement.swiper) {
      swiperElement.swiper.destroy(true, true);
    }
    new Swiper(swiperElement, {
      slidesPerView: 1.12,
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: false,
      navigation: {
        nextEl: navigation.next,
        prevEl: navigation.prev
      },
      breakpoints: CART_BUY_TOGETHER_BREAKPOINTS
    });
  }
  function initCartBuyTogetherSections() {
    document.querySelectorAll(CART_BUY_TOGETHER_SELECTOR).forEach(initCartBuyTogether);
  }
  $(function () {
    window.setTimeout(initCartBuyTogetherSections, 0);
  });
});

/***/ }),
/* 14 */
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function () {
  "use strict";

  function tuneProductThumbsCarousel() {
    var thumbsCarousel = $.productThumbsCarousel;
    var $thumbsCarousel = $('.page-product-product .productThumbsCarousel');
    var isDesktop = window.matchMedia('(min-width: 1040px)').matches;
    if (!thumbsCarousel || thumbsCarousel.destroyed) {
      $thumbsCarousel.addClass('ad-product-thumbs-ready');
      return false;
    }
    if (isDesktop) {
      thumbsCarousel.params.slidesPerView = 'auto';
      thumbsCarousel.params.breakpoints = {};
      thumbsCarousel.originalParams.slidesPerView = 'auto';
      thumbsCarousel.originalParams.breakpoints = {};
    }
    thumbsCarousel.update();
    if (thumbsCarousel.navigation) {
      thumbsCarousel.navigation.update();
    }
    if (isDesktop && !thumbsCarousel.__adDesktopBackSyncDisabled) {
      thumbsCarousel.off('transitionStart');
      thumbsCarousel.__adDesktopBackSyncDisabled = true;
    }
    $thumbsCarousel.addClass('ad-product-thumbs-ready');
    return true;
  }
  $(function () {
    if (!$('.page-product-product .productThumbsCarousel').length) {
      return;
    }
    $(window).one('load', tuneProductThumbsCarousel);
  });
});

/***/ }),
/* 15 */
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function () {
  "use strict";

  var PRODUCT_PAGE_SELECTOR = ".page-product-product";
  var PRODUCT_ROOT_SELECTOR = "#product";
  var DESCRIPTION_SELECTOR = "#description_resume";
  var BUY_CONTENT_SELECTOR = ".product-buy-button-content, .product-login-info, .product-download-list-button";
  var SHOP_CONTENT_SELECTOR = ".row.product-shop-content";
  var FULL_DESCRIPTION_SELECTOR = ".product-description-content";
  var READY_CLASS = "js-short-desc";
  function buildAccordionMarkup(content, withMoreButton) {
    var moreButton = withMoreButton ? "<button type=\"button\" class=\"product-short-description__more\">Veja mais</button>" : "";
    return "\n    <details class=\"product-short-description__accordion\" open>\n      <summary class=\"product-short-description__summary\">\n        <span class=\"product-short-description__label\">Descri\xE7\xE3o</span>\n        <span class=\"product-short-description__icon\" aria-hidden=\"true\"></span>\n      </summary>\n      <div class=\"product-short-description__panel\">\n        <div class=\"product-short-description__content\">".concat(content, "</div>\n        ").concat(moreButton, "\n      </div>\n    </details>\n  ");
  }
  function scrollToFullDescription() {
    var target = document.querySelector(FULL_DESCRIPTION_SELECTOR);
    if (target) {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  }
  function placeDescription(root, description) {
    var shopContent = root.querySelector(SHOP_CONTENT_SELECTOR);
    var buyContent = root.querySelector(BUY_CONTENT_SELECTOR);
    if ((shopContent === null || shopContent === void 0 ? void 0 : shopContent.parentElement) === description.parentElement) {
      shopContent.before(description);
      return;
    }
    if (buyContent) {
      buyContent.insertAdjacentElement("afterend", description);
    }
  }
  function enhanceShortDescription(page) {
    var root = page.querySelector(PRODUCT_ROOT_SELECTOR);
    var description = page.querySelector(DESCRIPTION_SELECTOR);
    if (!root || !description || description.dataset.accordionReady === "true") {
      return;
    }
    var content = description.innerHTML.trim();
    if (!content) {
      return;
    }
    var hasFullDescription = !!document.querySelector(FULL_DESCRIPTION_SELECTOR);
    description.classList.add("product-short-description");
    description.innerHTML = buildAccordionMarkup(content, hasFullDescription);
    if (hasFullDescription) {
      var moreButton = description.querySelector(".product-short-description__more");
      moreButton === null || moreButton === void 0 || moreButton.addEventListener("click", scrollToFullDescription);
    }
    placeDescription(root, description);
    requestAnimationFrame(function () {
      description.dataset.accordionReady = "true";
    });
  }
  function init() {
    document.querySelectorAll(PRODUCT_PAGE_SELECTOR).forEach(enhanceShortDescription);
  }
  document.documentElement.classList.add(READY_CLASS);
  $(init);
});

/***/ })
/******/ 	]);
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(0);
/******/ 	
/******/ })()
;